var spanishTranslation = {
    translations: {
        philippinePassport: "Pasaporte filipino",
        seamanBook: "Libro de marinero",
        philSysID: "Identificación PhilSys",
        iBP: "Colegio de Abogados Integrado de Filipinas (IBP)",
        driversLicense: "Licencia de conducir",
        loading: "Cargando...",
        loadingDataProvider: "Cargando proveedor de datos...",
        tallySheetImport: {
            title: "Importaciones de actas de escrutinio",
            subtitle: "Importa archivos de actas de escrutinio ES&S o CSV, previsualiza las urnas generadas y apruébalas antes de crear actas de escrutinio.",
            createTitle: "Importar actas de escrutinio",
            detailTitle: "Importación de acta de escrutinio",
            empty: "Todavía no hay importaciones de actas de escrutinio.",
            emptyBody: "Empieza importando un archivo ES&S Enhanced XML o CSV canónico para este evento electoral.",
            sourceFormat: {
                ESS_ENHANCED_XML: "ES&S Enhanced XML",
                CANONICAL_CSV: "CSV canónico",
            },
            channel: {
                PAPER: "Papel",
                POSTAL: "Postal",
                IN_PERSON: "Presencial",
            },
            table: {
                created: "Creado",
                createdBy: "Creado por",
                file: "Archivo",
                format: "Formato",
                channel: "Canal",
                status: "Estado",
                labels: "Etiquetas",
                annotations: "Anotaciones",
                actions: "Acciones",
            },
            summary: {
                imported: "Importadas",
                changed: "Modificadas",
                new: "Nuevas",
                unchanged: "Sin cambios",
                conflicted: "En conflicto",
                errors: "Errores",
            },
            status: {
                PENDING_REVIEW: "Pendiente de revisión",
                APPROVED: "Aprobada",
                DISAPPROVED: "Desaprobada",
                FAILED_VALIDATION: "Validación fallida",
                CONFLICTED: "En conflicto",
                NEW: "Nueva",
                CHANGED: "Modificada",
                UNCHANGED: "Sin cambios",
            },
            fields: {
                format: "Formato",
                channel: "Canal",
                supportedFormats: "Formatos admitidos: XML, CSV",
                generatedTallySheet: "Acta de escrutinio generada",
                sourceCandidates: "IDs de candidatos de origen",
                none: "Ninguno",
            },
            actions: {
                create: "Importar actas de escrutinio",
                review: "Revisar",
                source: "Origen",
                cancel: "Cancelar",
                preview: "Previsualizar",
                save: "Guardar importación",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                close: "Cerrar",
                openExisting: "Abrir existente",
            },
            notifications: {
                selectFile: "Selecciona un archivo de importación antes de previsualizarlo",
                duplicateSource: "Este hash de archivo de origen ya aparece en una importación de acta de escrutinio anterior.",
                uploadUrlError: "No se pudo crear la URL de subida",
                uploadError: "No se pudo subir el archivo de importación",
                previewEmpty: "La respuesta de la previsualización estaba vacía",
                previewError: "No se pudo previsualizar la importación",
                importEmpty: "La respuesta de la importación estaba vacía",
                created: "Se ha creado la importación del acta de escrutinio",
                createError: "No se pudo crear la importación",
                reviewEmpty: "La respuesta de la revisión estaba vacía",
                conflicted: "La importación tiene conflictos de línea base desactualizados",
                approved: "Se ha aprobado la importación",
                disapproved: "Se ha desaprobado la importación",
                reviewError: "No se pudo revisar la importación",
                sourceUrlError: "No se pudo crear la URL de descarga de origen",
                sourceDownloadError: "No se pudo descargar el archivo de origen",
            },
            pagination: {
                range: "{{rangeStart}}-{{rangeEnd}} de {{total}}",
                previous: "Anterior",
                next: "Siguiente",
            },
        },
        reconciliation: {
            menuButton: "Sincr. votantes ext.",
            categories: {
                VOTED_INTERNET: "Votó por Internet",
                VOTED_OTHER_CHANNEL: "Votó por otro canal",
                DISABLED_DELETE_CALL: "Votante deshabilitado",
                DELETION_REVERTED: "Eliminación revertida",
                PROFILE_UPDATE: "Perfil actualizado",
                VOTER_ADDED: "Votante añadido",
                REENABLED: "Votante rehabilitado",
                VOTED_UNMARKED: "Votante desmarcado como votante",
                ROW_FAILURE: "Fallo de fila",
            },
            table: {
                voterId: "ID de Votante",
                field: "Campo",
                category: "Categoría",
                currentValue: "Valor actual",
                newValue: "Valor nuevo",
                reason: "Motivo",
                rowLabel: "Fila",
                noDifferences: "No se encontraron diferencias - los sistemas están sincronizados.",
            },
            wizard: {
                title: "Sincronización de reconciliación externa",
                subtitle: "Sincroniza la lista de votantes con el sistema externo",
                drop: {
                    description: "Suelta el archivo de reconciliación generado por el sistema externo - ambos diffs (lado externo y lado Sequent) se calculan automáticamente y se muestran en tablas separadas.",
                    fileFormatLabel: "Archivo CSV",
                    uploading: "Subiendo {{fileName}} y calculando ambos diffs...",
                },
                review: {
                    fileSummary: "{{fileName}} - Secuencia {{sequence}}, generado {{generatedAt}}",
                    rowFailuresWarning: "{{count}} fila(s) no se pudieron reconciliar de forma segura y quedan excluidas de ambos diffs - ver detalles abajo.",
                    noDifferences: "No hay diferencias - ambos sistemas ya están sincronizados.",
                    diffOnlyDifferences: "Esta es una comprobación de convergencia de una secuencia ya aplicada. Las diferencias se muestran para su seguimiento, pero esta ronda no se puede volver a aplicar.",
                    externalDiffTitle: "Diff externo",
                    sequentDiffTitle: "Diff de Sequent",
                    downloadExternalPatch: "Descargar parche externo",
                    externalDiffCaption: "Descarga el parche y entrégaselo al sistema externo fuera de esta herramienta. Cuando lo aplique y genere el siguiente archivo de reconciliación, haz clic en 'Atrás' y suelta ese archivo - 'Aplicar' se habilita cuando esta tabla esté vacía.",
                    noExternalDifferences: "No hay diferencias del lado externo.",
                    sequentDiffCaption: "Aplica los cambios directamente a Sequent haciendo clic en 'Aplicar' - no se genera archivo de parche para estos.",
                    noSequentDifferences: "No hay diferencias del lado de Sequent.",
                },
                applying: {
                    inProgress: "Aplicando cambios del lado de Sequent...",
                    rowFailures: "{{count}} fila(s) quedaron excluidas de esta ronda y requieren seguimiento manual - ver detalles abajo.",
                    rowFailuresTruncated: "Se muestran los primeros {{shown}} de {{count}} fallos de fila. Resuelve la causa común y vuelve a intentarlo para ver los fallos restantes.",
                    success: "Todos los cambios del lado de Sequent se aplicaron correctamente.",
                },
                actions: {
                    cancel: "Cancelar",
                    back: "Atrás",
                    apply: "Aplicar",
                    next: "Siguiente",
                    startOver: "Empezar de nuevo",
                    close: "Cerrar",
                },
                confirm: {
                    title: "Confirmar cambios de reconciliación",
                    categoriesNote: "Las categorías resaltadas en naranja ({{categories}}) afectan el estado de voto o deshabilitan votantes.",
                    applyChanges: "Aplicar cambios",
                    continue: "Continuar",
                },
                summary: {
                    votedOtherChannel: "marca {{count}} votante(s) como votado(s) por otro canal",
                    disabled: "deshabilita {{count}} votante(s)",
                    reenabled: "rehabilita {{count}} votante(s)",
                    votedUnmarked: "desmarca {{count}} votante(s) como votante",
                    profileUpdated: "actualiza {{count}} perfil(es)",
                    voterAdded: "añade {{count}} votante(s)",
                    prefix: "Esto aplicará cambios que {{parts}}.",
                    empty: "No hay cambios del lado de Sequent para aplicar.",
                },
                notifications: {
                    envelopeLoadError: "No se pudo cargar el diff de reconciliación - inténtalo de nuevo.",
                    generateFailed: "No se pudo calcular el diff de reconciliación - consulta el widget de tareas para más detalles.",
                    applyFailed: "No se pudieron aplicar los cambios del lado de Sequent - consulta el widget de tareas para más detalles.",
                    uploadUrlError: "No se pudo obtener una URL de subida",
                    generateTaskError: "No se pudo iniciar la tarea de diff de reconciliación",
                    uploadError: "No se pudo subir el archivo de reconciliación",
                    applyTaskError: "No se pudo iniciar la tarea de aplicación",
                    applyError: "No se pudieron aplicar los cambios de reconciliación",
                },
            },
        },
        logsScreen: {
            noPermissions: "No tienes permiso para acceder a las bitácoras.",
            title: "Bitácoras",
            subtitle: "Bitácoras generales de las baseses de datos principal y de IAM.",
            column: {
                id: "ID",
                statement_kind: "Tipo de declaración",
                created: "Creado",
                statement_timestamp: "Marca de tiempo de declaración",
                message: "Mensaje",
                user_id: "ID de usuario",
                username: "Nombre de Usuario",
                sender_pk: "Clave primaria del remitente",
                log_type: "Tipo de registro",
                event_type: "Tipo de evento",
                description: "Descripción",
                version: "Versión",
            },
            exportdialog: {
                description: "Por favor, confirma que deseas ejecutar esta acción; puede tardar un tiempo en completarse.",
            },
            actions: {
                csv: "Exportar en CSV",
                pdf: "Exportar en PDF",
            },
            main: {
                title: "Bitácora de Base de Datos Principal",
            },
            iam: {
                title: "Bitácora de Base de Datos de IAM",
            },
        },
        tasksScreen: {
            noPermissions: "No tienes permiso para acceder a los registros.",
            title: "Ejecución de tareas",
            subtitle: "Información sobre las tareas ejecutadas",
            taskInformation: "Información de la tarea",
            status: "estado: {{status}}",
            ok: "Aceptar",
            column: {
                id: "Índice",
                name: "Nombre de la tarea",
                type: "Tipo",
                execution_status: "Estado",
                start_at: "Hora de inicio",
                end_at: "Hora de finalización",
                executed_by_user: "Ejecutor",
                annotations: "Anotaciones",
                labels: "Etiquetas",
                logs: "Registros",
            },
            tasksExecution: {
                DELETE_TENANT: "Eliminar organización",
                PUBLISH_BALLOT: "Publicar papeleta",
                VOTER_INFORMATION_LETTER: "Carta de información para el votante",
                EXPORT_ELECTION_EVENT: "Exportar evento electoral",
                CREATE_ELECTION_EVENT: "Crear Evento Electoral",
                IMPORT_ELECTION_EVENT: "Importar evento electoral",
                IMPORT_USERS: "Importar usuarios",
                EDIT_USER: "Editar votante",
                IMPORT_CANDIDATES: "Importar candidatos",
                EXPORT_VOTERS: "Exportar votantes",
                CREATE_TRANSMISSION_PACKAGE: "Crear paquete de transmisión",
                EXPORT_BALLOT_PUBLICATION: "Exportar Publicación de Boleta",
                EXPORT_ACTIVITY_LOGS_REPORT: "Exportar Informe de Registros de Actividad",
                GENERATE_REPORT: "Generar Reporte",
                GENERATE_TRANSMISSION_REPORT: "Generar Informe de Transmisión",
                EXPORT_TRUSTEES: "Exportar Autoridades",
                EXPORT_APPLICATION: "Exportar Solicitudes",
                EXPORT_TENANT_CONFIG: "Exportar Configuración del Cliente",
                IMPORT_TENANT_CONFIG: "Importar Configuración del Cliente",
                RENDER_DOCUMENT_PDF: "Renderizar el documento PDF",
                CREATE_TENANT: "Crear Inquilino",
                EXPORT_TEMPLATES: "Exportar Plantillas",
                IMPORT_TEMPLATES: "Importar Plantillas",
                DELETE_ELECTION_EVENT: "Eliminar evento electoral",
                DELETE_VOTERS: "Delete Voters",
                PREPARE_PUBLICATION_PREVIEW: "Preparar la vista previa de la publicación",
                EXPORT_TALLY_RESULTS_XLSX: "Exportar los resultados del escrutinio en formato XLSX",
                EXPORT_CERTIFICATE_AUTHORITIES: "Exportar autoridades de certificación",
                PUBLISH_RESULTS_WEBSITE: "Publicar sitio web de resultados",
            },
            documentAccess: {
                title: "Acceso al documento",
                sensitivityNotice: "Información confidencial. Comparta esta contraseña únicamente con el destinatario previsto.",
                passwordLabel: "Contraseña para abrir el PDF cifrado",
                showPassword: "Mostrar contraseña",
                copyPassword: "Copiar contraseña",
                passwordCopied: "Contraseña copiada",
                passwordError: "No se pudo recuperar la contraseña del PDF",
                copyError: "No se pudo copiar la contraseña",
                guidance: "La contraseña se carga únicamente después de elegir Mostrar contraseña. Una vez cargada, aparecerá aquí un campo de solo lectura con la opción de copiar.",
            },
            widget: {
                taskTitle: "Tarea: {{title}}",
                viewTask: "Ver Tarea",
                downloadDocument: "Descargar Archivo",
            },
            exportTasksExecution: {
                success: "La exportación se completó con éxito",
                error: "Error al exportar la Ejecución de Tareas",
            },
        },
        areas: {
            common: {
                title: "Áreas",
                subTitle: "Configuración de Área.",
                deleteError: "Error borrando Área",
            },
            createAreaSuccess: "Área creada",
            updateAreaSuccess: "Área actualizada",
            createAreaError: "Error creando área",
            sequent_backend_area_contest: "Preguntas del Área",
            empty: {
                header: "No hay Áreas aún.",
                action: "Crear un Área",
            },
            formImputs: {
                allowEarlyVoting: "Permitir Votación Temprana",
            },
        },
        integrationsScreen: {
            common: {
                gapiKey: "Clave de Cuenta de Servicio de Google Calendar",
                gapiEmail: "Correo de Autenticación de Google Calendar",
            },
            errors: {
                invalidGapiKey: "Formato de Clave de Cuenta de Servicio de Google Calendar inválido",
            },
        },
        lookAndFeelScreen: {
            common: {
                helpLinks: "Enlaces de Ayuda",
                logoUrl: "Logo URL",
                css: "CSS Personalizado",
            },
            errors: {
                invalidHelpLinks: "Formato de Enlaces de Ayuda inválido",
            },
        },
        electionTypeScreen: {
            noPermissions: "No tienes permiso para acceder a la configuración.",
            common: {
                title: "Tipo de Elección",
                subtitle: "Configuración del Tipo de Elección",
                onlineVoting: "Votación en Línea",
                kioskVoting: "Votación en Quiosco",
                telephoneVoting: "Votación Telefónica",
                settingTitle: "Configuración",
                settingSubtitle: "Ajustes generales",
                sms: "SMS",
                mail: "Mails",
                createNew: "Crear un Tipo de Elección",
                emptyHeader: "No hay Tipos de Elección aún.",
                emptyBody: "¿Quieres crear uno?",
            },
            create: {
                title: "Crear Tipo de Elección",
            },
            edit: {
                title: "Editar Tipo de Elección",
            },
            tabs: {
                votingChannels: "CANALES DE VOTACIÓN",
                electionTypes: "TIPOS DE ELECCIÓN",
                templates: "PLANTILLAS",
                languages: "IDIOMAS",
                localization: "LOCALIZACIÓN",
                integrations: "INTEGRACIONES",
                lookAndFeel: "PERSONILIZACIÓN DE APARIENCIA",
                schedules: "EVENTOS PROGRAMADOS",
                trustees: "AUTORIDADES",
                BackupRestore: "COPIA DE SEGURIDAD / RESTAURAR",
            },
        },
        trusteesSettingsScreen: {
            common: {
                emptyHeader: "Aún no hay fideicomisarios.",
                createNew: "Crear fideicomisario",
                title: "Fideicomisario",
                subtitle: "Configuración del fideicomisario",
                emptyBody: "¿Quieres crear uno?",
            },
            create: {
                title: "Crear fideicomisario",
            },
            edit: {
                title: "Editar fideicomisario",
            },
        },
        scheduleScreen: {
            noPermissions: "No tienes permiso para acceder a la configuración.",
            createScheduleSuccess: "Fecha creada",
            createScheduleError: "Error creando fecha",
            deleteScheduleSuccess: "Fecha borrada",
            deleteScheduleError: "Error borrando fecha",
            common: {
                title: "Programado",
                subtitle: "Configuración de fechas",
                createNew: "Crear fecha",
                emptyHeader: "Aún no hay fechas.",
                emptyBody: "¿Quieres crear uno?",
            },
            create: {
                title: "Crear fecha",
                selectSchedule: "Seleccione un horario de la lista predefinida o escriba uno personalizado",
            },
            edit: {
                title: "Editar fecha",
            },
            eventTypes: {
                SYSTEM_LOCKDOWN_FOR_INTERNET_VOTING_SETTINGS: "Bloqueo del sistema para la finalización de la configuración de votación por Internet",
                START_PRE_REGISTRATION_OVCS: "Inicio de la preinscripción para OVCS",
                END_PRE_REGISTRATION_OVCS: "Fin de la preinscripción para OVCS",
                START_TEST_VOTING_PERIOD: "Inicio del período de votación de prueba",
                END_TEST_VOTING_PERIOD: "Fin del período de votación de prueba",
                START_INTERNET_VOTING_PERIOD: "Inicio del período de votación por Internet",
                END_INTERNET_VOTING_PERIOD: "Fin del período de votación por Internet",
                LAB_TEST: "Prueba de laboratorio",
                FIELD_TEST: "Prueba de campo",
                MOCK_ELECTIONS: "Elecciones simuladas",
                FTS: "FTS",
            },
        },
        dashboard: {
            voteByDay: "Votos por día",
            votesOverTime: "Votos a lo largo del tiempo",
            timeResolution: "Resolución temporal",
            timeRange: "Intervalo de tiempo",
            minute: "Minuto",
            hour: "Hora",
            day: "Día",
            votersByChannels: "Votantes por canales",
            voterLoginURL: "URL de inicio de sesión de votantes",
            voterEnrollURL: "URL de inscripción de votantes",
            voterEnrollKioskURL: "Kiosk URL de inscripción de votantes",
            ipAddress: {
                emptyState: "Aún no hay votos.",
                title: "IP Addresses",
                ip: "IP",
                country: "País",
                VoteCount: "Número de votos",
                ElectionName: "Nombre de la elección",
                VotersId: "Identificadores de votantes",
            },
        },
        electionEventScreen: {
            common: {
                subtitle: "Configuración del Evento Electoral.",
                showMore: "Mostrar más",
                showLess: "Mostrar menos",
                adminPortal: "Portal de Administración",
                allowPublishAfterLockdown: "Only allow election event publishing after lockdown",
                reset: "Restablecer filtro personalizado",
            },
            edit: {
                general: "General",
                dates: "Fechas",
                customUrls: "Prefixo de URLs personalizados",
                votingPeriod: "Período de votación",
                language: "Idiomas",
                allowed: "Canales de Voto Permitidos",
                materials: "Materiales de Soporte",
                ballotDesign: "Diseño de la Papeleta",
                templates: "Plantillas",
                reorder: "Reordenar elecciones",
                advancedConfigurations: "Voting Portal Countdown Policy",
                importCandidates: "Importar Candidatos",
                custom_filters: "Filtros personalizados",
                voter_authentication: "Autenticación de votantes",
                realm_attributes: "Keycloak realm attributes",
                realm_attributes_load_error: "Error loading Keycloak realm attributes",
                realm_attributes_update_error: "Error updating Keycloak realm attributes",
                realm_attributes_not_loaded: "Keycloak realm attributes have not loaded, changes were not saved",
                password_policy: "Password Policy",
                password_policy_load_error: "Error loading Keycloak password policy",
                password_policy_update_error: "Error updating Keycloak password policy",
                password_policy_not_loaded: "Keycloak password policy has not loaded, changes were not saved",
            },
            customUrls: {
                login: "Inicio de sesión",
                enrollment: "Inscripción",
            },
            localization: {
                emptyHeader: "No se han establecido idiomas para el evento",
                selectLanguage: "Seleccionar idioma",
                notify: {
                    success: "Localización actualizada con éxito",
                    error: "La actualización de la localización ha fallado",
                    duplicateKey: "Ya existe una sustitución con esta clave y ámbito del portal.",
                    invalidDateTimeFormat: "Formato de fecha/hora no válido. Usa los tokens yyyy, MM, dd, HH, mm, ss (p. ej. dd/MM/yyyy HH:mm).",
                },
                common: {
                    title: "Localización",
                    subTitle: "Configuración de la localización",
                },
                labels: {
                    key: "Clave",
                    scope: "Ámbito del portal",
                    value: "Valor",
                },
                scopes: {
                    legacy: "Heredado ({{portal}})",
                    global: "Global",
                    votingPortal: "Portal de votación",
                    ballotVerifier: "Verificador de papeletas",
                    resultsPortal: "Portal de resultados",
                    adminPortal: "Portal de administración",
                },
            },
            field: {
                passwordPolicy: {
                    minimumLength: "Longitud mínima",
                    maximumLength: "Longitud máxima",
                    includeUppercase: "Incluir letras mayúsculas",
                    includeLowercase: "Incluir letras minúsculas",
                    includeDigits: "Incluir dígitos",
                    includeSpecialCharacters: "Incluir caracteres especiales",
                    help: {
                        minimumLength: "El número mínimo de caracteres requeridos para la contraseña.",
                        maximumLength: "El número máximo de caracteres permitidos para la contraseña.",
                        includeUppercase: "La contraseña debe incluir al menos una letra mayúscula.",
                        includeLowercase: "La contraseña debe incluir al menos una letra minúscula.",
                        includeDigits: "La contraseña debe incluir al menos un dígito.",
                        includeSpecialCharacters: "La contraseña debe incluir al menos un carácter especial.",
                    },
                    notConfigured: "No hay ninguna política de contraseñas configurada. Al guardar se aplicarán los valores predeterminados que se muestran a continuación.",
                    errors: {
                        lengthRange: "Las longitudes de la contraseña deben ser números enteros entre 1 y 256.",
                        minimumExceedsMaximum: "La longitud mínima no puede superar la longitud máxima.",
                        characterClassRequired: "Seleccione al menos una clase de caracteres para la contraseña.",
                    },
                },
                name: "Nombre",
                alias: "Alias",
                description: "Descripción",
                startDateTime: "Fecha y hora de inicio",
                endDateTime: "Fecha y hora de finalización",
                language: "Idioma",
                votingChannels: "Canales de Voto",
                materialActivated: "Materiales de Soporte activados",
                supportMaterialsPolicy: {
                    label: "Política de Materiales de Soporte",
                    helperText: "La opción Obligatorio para Votar requiere que los votantes abran cada Material de Soporte y confirmen que lo han leído antes de poder votar.",
                    options: {
                        off: "Desactivado",
                        optional: "Opcional",
                        mandatory_for_voting: "Obligatorio para Votar",
                    },
                },
                materialTitle: "Titulo",
                materialSubTitle: "Subtitulo",
                logoUrl: "Logo URL",
                userVerification: "Puede introducir una plantilla personalizada que se utilizará para verificar manualmente a los votantes",
                redirectFinishUrl: "URL de redirección al finalizar",
                kioskRedirectFinishUrl: "URL de redirección al finalizar del quiosco",
                css: "CSS personalizado",
                skipElectionList: "Saltar pantalla para escoger elección",
                showUserProfile: "Mostrar perfil de usuario",
                showCastVoteLogs: {
                    policyLabel: "Mostrar logs de votación",
                    options: {
                        "show-logs-tab": "Mostrar Tab de logs de votación",
                        "hide-logs-tab": "Ocultar Tab de logs de votación",
                    },
                },
                lockdownState: {
                    policyLabel: "Estado de Confinamiento",
                    options: {
                        "locked-down": "Confinado",
                        "not-locked-down": "No Confinado",
                    },
                },
                decodedBallots: {
                    policyLabel: "Incluir papeletas decodificadas en la base de datos de resultados",
                    options: { "included": "Incluir", "not-included": "No incluir" },
                },
                contestEncryptionPolicy: {
                    options: {
                        "single-contest": "Concurso único",
                        "multiple-contests": "Varios concursos",
                    },
                    policyLabel: "Política de cifrado de concurso",
                },
                votingPortalDateTimeFormat: {
                    policyLabel: "Formato de fecha y hora del portal de votación",
                    helperText: 'Se aplica a todo el evento. Para anularlo por idioma, añade la clave "votingPortalDateTimeFormat" en la pestaña Localización usando los tokens yyyy, MM, dd, HH, mm, ss (p. ej. dd/MM/yyyy HH:mm). Consulta la documentación para más detalles.',
                    options: {
                        "legacy-gb-24h": "Legacy GB 24h (dd/MM/yyyy HH:mm, 24h)",
                        "iso-local": "ISO Local (yyyy-MM-dd HH:mm)",
                        "us-12h": "US 12h (MM/dd/yyyy h:mm AM/PM)",
                        "locale-medium": "Locale Medium (fecha media, hora corta)",
                        "date-only": "Date Only (sin hora)",
                        "custom": "Formato personalizado",
                    },
                    customFormat: {
                        label: "Formato de fecha y hora personalizado",
                        helperText: "Usa los tokens yyyy, MM, dd, HH, mm, ss (p. ej. dd/MM/yyyy HH:mm). Cualquier otro carácter se muestra literalmente.",
                        invalid: "Formato no válido. Usa al menos uno de los tokens yyyy, MM, dd, HH, mm, ss.",
                    },
                },
                countDownPolicyOptions: {
                    NO_COUNTDOWN: "Sin cuenta regresiva",
                    COUNTDOWN: "Cuenta regresiva",
                    COUNTDOWN_WITH_ALERT: "Cuenta regresiva con alerta",
                    sectionTitle: "Portal de votación",
                    policyLabel: "Política de cuenta regresiva del portal de votación",
                    coundownSecondsLabel: "tiempo en segundos antes de la expiración para mostrar la cuenta regresiva",
                    alertSecondsLabel: "tiempo en segundos antes de la expiración para mostrar la alerta de cierre de sesión",
                },
                voterSigningPolicy: {
                    "policyLabel": "Política de Firma de Votantes",
                    "no-signature": "Sin firma",
                    "with-signature": "Con firma",
                },
                VoterCertificatePolicy: {
                    policyLabel: "Voter Digital Certificate Policy",
                    enabled: "Habilitado",
                    disabled: "Deshabilitado",
                },
                enrollment: {
                    policyLabel: "Inscripción",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                otp: {
                    policyLabel: "OTP",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                ceremoniesPolicy: {
                    policyLabel: "Política de ceremonias de llaves/recuento",
                    options: {
                        "automated-ceremonies": "Permitir ceremonias automáticas",
                        "manual-ceremonies": "Ceremonias manuales",
                    },
                },
                automaticRecountPolicy: {
                    policyLabel: "Recuento automático tras aprobar una importación",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                weightedVotingPolicy: {
                    policyLabel: "Política de Votación Ponderada",
                    options: {
                        "areas-weighted-voting": "Votación Ponderada por Áreas",
                        "voters-weighted-voting": "Votación Ponderada por Votantes",
                        "disabled-weighted-voting": "Votación Ponderada Deshabilitada",
                    },
                    noDelegated: "La Votación Ponderada por Votantes no puede combinarse con el Voto Delegado",
                    noDecodedBallots: "La Votación Ponderada por Votantes no puede combinarse con la inclusión de papeletas descifradas en los resultados",
                },
                delegatedVotingPolicy: {
                    policyLabel: "Política de Votación Delegada",
                    options: {
                        enabled: "Habilitado",
                        disabled: "Deshabilitado",
                    },
                },
                languageDetectionPolicy: {
                    policyLabel: "Política de detección de idioma",
                    options: {
                        "browser-detect": "Detectar desde el navegador",
                        "force-default": "Forzar predeterminado",
                    },
                },
            },
            error: {
                endDate: "La fecha de finalización debe ser posterior a la fecha de inicio",
                noResult: "No Election Event yet",
                startDate: "La fecha de inicio debe ser en el futuro",
                endDateInvalid: "La fecha de finalización debe estar en el futuro",
            },
            voters: {
                title: "Votantes",
            },
            createElectionEventSuccess: "Evento Electoral creado",
            createElectionEventError: "Error creando Evento Electoral",
            ivr: {
                tabs: {
                    config: "Configuración",
                    blacklist: "Lista de bloqueo",
                    prompts: "Locuciones",
                    emulator: "Emulador",
                },
                common: {
                    saveSuccess: "Guardado correctamente",
                    saveError: "No se pudo guardar",
                    deleteSuccess: "Eliminado correctamente",
                    deleteError: "No se pudo eliminar",
                },
                config: {
                    configuredPhone: "Número de teléfono configurado",
                    infoMsg: "Configure el flujo del IVR y sus propiedades a continuación. Para más detalles, póngase en contacto con Sequent.",
                },
                prompts: {
                    emptyMsg: "Aún no se ha creado ningún mensaje",
                    infoMsg: "Configure los mensajes utilizados por el IVR. Los mensajes de anuncio son obligatorios, y los mensajes del sistema se pueden sobrescribir para los idiomas deseados. Se admite SSML, incluso para mezclar idiomas.",
                    editorTitle: "Mensaje",
                    editorSubtitle: "Configuración del mensaje",
                },
                blacklist: {
                    columns: {
                        phone: "Número de teléfono",
                        reason: "Motivo",
                        createdAt: "Creado el",
                        createdBy: "Creado por",
                        createdBefore: "Creado antes",
                        createdAfter: "Creado después",
                    },
                    emptyMsg: "No hay entradas en la lista de bloqueo",
                    infoMsg: "Configure la lista de bloqueo del IVR. Las llamadas de estos números serán desconectadas automáticamente por el sistema.",
                    noFilterMatch: "Ninguna entrada coincide con los filtros indicados",
                    phoneRequired: "El número de teléfono es obligatorio",
                },
                emulator: {
                    infoMsg: "Seleccione un área y las elecciones deseadas para probar la sesión de IVR.",
                    apiStatus: {
                        unavailable: "El sistema del emulador no está disponible en su entorno",
                        loading: "Cargando el sistema del emulador",
                        error: "Error al cargar el sistema del emulador",
                    },
                    hints: {
                        title: "Sugerencias",
                        publishRequired: "Cualquier cambio realizado en las elecciones, contiendas o candidatos debe publicarse primero para que esté disponible. En el emulador solo se utilizarán los estilos de boleta publicados más recientemente para el área correspondiente.",
                        eventChangesImmediate: "Los cambios realizados en el evento electoral, como la configuración de IVR o las modificaciones de los mensajes, están disponibles inmediatamente al reiniciar la sesión del emulador.",
                        credentials: 'El identificador de votante y el PIN válidos son "123" y "123".',
                    },
                    sendDtmf: "Enviar entrada DTMF",
                    sendTimeout: "Enviar tiempo de espera",
                    disconnected: "Desconectado",
                    startSession: "Iniciar nueva sesión",
                    endSession: "Finalizar la sesión",
                    noStylesFound: "No se encontraron estilos de boleta publicados que coincidan con sus selecciones",
                    inputPlaceholder: "Introduzca su entrada (máximo de dígitos={{maxDigits}}, entradas válidas={{validInputs}}, tiempo de espera={{timeout}} s)",
                    blacklistCaller: "Bloquear a la persona que llama",
                    elections: "Elecciones",
                    area: "Área",
                },
            },
            stats: {
                elegibleVoters: "Electores",
                voters: "Votantes",
                elections: "Elecciones",
                contests: "Preguntas",
                areas: "Áreas",
                sentEmails: "Emails Enviados",
                sentSMS: "SMS Enviados",
                calendar: {
                    title: "Calendario",
                    scheduled: "Programado",
                },
            },
            keys: {
                createNew: "Crear Ceremonia de Claves",
                emptyHeader: "Ninguna Ceremonia de Claves aún.",
                statusLabel: "Estado",
                waitingKeys: "Esperando a la Generación de Claves..",
                started: "Iniciada en",
                actions: {
                    participate: "Participar en la ceremonia de claves",
                    view: "Ver la ceremonia de claves",
                },
                breadCrumbs: {
                    configure: "Configurar",
                    ceremony: "Ceremonia",
                    created: "Finished",
                    start: "Comienzo",
                    status: "Estado",
                    download: "Descargar",
                    check: "Comprobar",
                    success: "Finalizado",
                },
                notify: {
                    participateNow: "Ha sido invitado a participar a una Ceremonia de Claves. Por favor <1>haz clic abajo en la acción de llave de la ceremonia</1> para participar.",
                },
            },
            tabs: {
                dashboard: "Panel de Control",
                monitoring: "Monitoreo",
                data: "Datos",
                ivr: "IVR",
                localization: "Localización",
                voters: "Votantes",
                areas: "Áreas",
                keys: "Claves",
                tally: "Recuento",
                tallySheetImports: "Importación de actas",
                publish: "Publicar",
                logs: "Logs",
                tasks: "Tareas",
                events: "Eventos Programados",
                notifications: "Notificaciones",
                reports: "Informe",
                approvals: "Aprobaciones",
                cas: "Certificados",
            },
            tally: {
                emptyHeader: "Ningún Recuento aún.",
                title: "Recuento del Evento Electoral",
                elections: "Elecciones",
                electionNumber: "Número de Elecciones",
                trustees: "Trustees",
                status: "Estado",
                permissionLabels: "Etiquetas de Permisos",
                tallyType: {
                    label: "Tipo de Conteo",
                    ELECTORAL_RESULTS: "Resultados Electorales",
                    INITIALIZATION_REPORT: "Resultados de Inicialización",
                },
                create: {
                    title: "Crear Recuento",
                    subtitle: "Crear un nuevo Recuento para este Evento Electoral",
                    createTallyButton: "Iniciar la Ceremonia de Recuento",
                    createInitializationReportButton: "Crear Informe de Inicialización",
                    error: {
                        create: "Error creando Recuento",
                    },
                    success: "Recuento creado",
                },
                logs: {
                    noLogs: "No hay registros disponibles",
                },
                notify: {
                    noKeysTally: "La Ceremonia de Recuento no puede comenzar hasta que la Ceremonia de Claves se haya completado con éxito.",
                    noPublication: "La Ceremonia de Escrutinio no puede comenzar hasta que crees una publicación en la pestaña Publicar.",
                    participateNow: "Ha sido invitado a participar a una Ceremonia de Recuento. Por favor <1>haz clic abajo en la acción de llave de la ceremonia</1> para participar.",
                    startDisabled: "No puedes continuar con la ceremonia porque no se han seleccionado elecciones o las elecciones no están publicadas.",
                    ceremonyDisabled: "No puedes continuar con la ceremonia porque la sesión de recuento no está conectada o el inicio de la ceremonia no está permitido.",
                },
            },
            importAreas: {
                title: "Importar Áreas",
                subtitle: "Importar datos de áreas",
                areaParagraph: "Importar áreas utilizando un archivo de hoja de cálculo en formato de valores separados por comas (CSV).",
                importSuccess: "Áreas Importadas Exitosamente",
                importError: "Error al importar Áreas",
                upsert: "Upsert Areas",
            },
            import: {
                eetitle: "Importar Evento Electoral",
                eesubtitle: "Importar datos del Evento Electoral",
                title: "Importar votantes",
                subtitle: "Importar votantes al Evento Electoral",
                voters: "Voters",
                votersParagraph: "Importa votantes usando una hoja de cálculo en formato Comma Separated Values (CSV) format. Descarga un ejemplo de fichero de importación CSV aquí.",
                electionEventParagraph: "Importa Eventos Electorales usando un fichero JSON.",
                elections: "Elections",
                areas: "Areas",
                sha: "Verificación de Integridad (SHA 256)",
                cancel: "Cancelar",
                import: "Importar",
                fileUploadSuccess: "Fichero subido al servidor - pero no importado aún",
                fileUploadError: "Error subiendo el fichero",
                importVotersSuccess: "Importación de Votantes lanzada en segundo plano con éxito.",
                importVotersError: "Error Importando Votantes.",
                importElectionEventSuccess: "Election event imported Successfully",
                importElectionEventError: "Error importing election event",
                shaDialog: {
                    ok: "Sí, Importar Sin Verificación de Integridad",
                    cancel: "Volver",
                    title: "Importar Sin Verificación de Integridad?",
                    description: "No ingresó el campo Verificación de integridad (SHA-256). Confirme que está importando el archivo correcto y que desea importarlo.",
                },
                passwordDialog: {
                    title: "Contraseña de Descifrado",
                    description: "Introduce la contraseña para descifrar el archivo",
                    label: "Contraseña",
                    copyPassword: "Copiar Contraseña",
                    ok: "Aceptar",
                },
            },
            export: {
                title: "Exportar Evento Electoral",
                subtitle: "La exportación puede ser una operación larga. ¿Estás seguro de que deseas exportar los registros?",
                encryptWithPassword: "Cifrar con Contraseña",
                passwordForcedNote: "El archivo se protegerá con contraseña de todos modos: los informes, las solicitudes y los datos del tablón se cifran siempre. Marca la casilla para incluir también los campos secretos de votante descifrados.",
                includeVoters: "Incluir Votantes",
                activityLogs: "Registros de Actividad",
                bulletinBoard: "Tablón de Anuncios",
                publications: "Publicaciones",
                s3Files: "Archivos S3",
                scheduledEvents: "Eventos Programados",
                exportSuccess: "Evento Electoral exportado con éxito",
                exportError: "Error al exportar el Evento Electoral",
                passwordTitle: "Contraseña",
                passwordDescription: "Contraseña para descifrar el archivo:",
                copiedSuccess: "Nakopya ang password sa clipboard",
                copiedError: "Error al copiar la contraseña",
                reports: "Informes",
                applications: "Aplicaciones",
                tally: "Recuento",
                certificates: "Certificados",
            },
            taskNotification: "{{action}} ha comenzado. Puedes ver su estado en la tabla de Ejecución de Tareas.",
        },
        electionScreen: {
            common: {
                title: "Elección",
                subtitle: "Configuración de la elección.",
                fileLoaded: "Archivo cargado",
                noPermission: "No tienes permiso para acceder a esta elección.",
            },
            edit: {
                general: "General",
                dates: "Fechas",
                votingPeriod: "Período de votación",
                language: "Idioma",
                allowed: "Canales de Voto Permitidos",
                default: "Por defecto",
                defaultLang: "Idioma predeterminado",
                receipts: "Comprobantes",
                image: "Imagen",
                advanced: "Configuración Avanzada",
                numAllowedVotes: "Número de votos permitidos",
                reorder: "Reordenar concursos",
                castVoteConfirm: "Modal de Confirmación de Voto",
                gracePeriodPolicy: "Política de período de gracia",
                allowTallyPolicy: "Permitir Recuento",
                permissionLabel: "Etiqueta de permiso",
                custom_filters: "Filtros personalizados",
            },
            field: {
                name: "Nombre",
                language: "Idioma",
                votingChannels: "Canales de Voto",
                startDateTime: "Fecha y hora de inicio",
                endDateTime: "Fecha y hora de finalización",
                startDateTimeWithTimezone: "Fecha y Hora de inicio ({{timezone}})",
                endDateTimeWithTimezone: "Fecha y Hora de finalización ({{timezone}})",
                scheduledOpening: "Apertura Programada",
                scheduledClosing: "Cierre Programado",
                alias: "Alias",
                description: "Descripción",
                securityConfirmationHtml: "Confirmación de seguridad HTML",
                ivrPrompt: "Mensaje IVR",
                externalId: "ID externo",
            },
            securityConfirmationPolicy: {
                label: "Política de la casilla de confirmación de seguridad",
                none: "Ninguno",
                mandatory: "Obligatorio",
            },
            error: {
                endDate: "La fecha de finalización debe ser posterior a la fecha de inicio",
                fileError: "Error al cargar el archivo",
                fileLoaded: "Archivo cargado",
                startDate: "La fecha de inicio debe ser en el futuro",
                endDateInvalid: "La fecha de finalización debe estar en el futuro",
            },
            createElectionEventSuccess: "Creada la elección",
            createElectionEventError: "Error Creando la elección",
            tabs: {
                dashboard: "Panel de Control",
                monitoring: "Monitoreo",
                data: "Datos",
                voters: "Votantes",
                publish: "Publicar",
                logs: "Logs",
                approvals: "Aprobaciones",
                tallySheets: "Hojas de Recuento",
            },
            gracePeriodPolicy: {
                "label": "Política de período de gracia",
                "no-grace-period": "Sin período de gracia",
                "grace-period-without-alert": "Período de gracia sin alerta",
                "gracePeriodSecs": "Tiempo de gracia en segundos",
            },
            allowTallyPolicy: {
                "allowed": "Permitido",
                "disallowed": "No permitido",
                "requires-voting-period-end": "Permitir cuando termine el periodo de votación",
            },
            initializeReportPolicy: {
                "label": "Inicializar Política de Reportes",
                "not-required": "No Requerido",
                "required": "Requerido",
            },
            castVoteGoldLevelPolicy: {
                label: "Gold level Authentication Policy",
                options: {
                    "gold-level": "Gold level Authentication",
                    "no-gold-level": "No Gold level Authentication",
                },
            },
            startScreenTitlePolicy: {
                label: "Política de título de pantalla de inicio",
                options: {
                    "election": "Elección",
                    "election-event": "Evento Electoral",
                },
            },
            consolidatedReportPolicy: {
                label: "Política de informe consolidado",
                options: {
                    "generate": "Generar",
                    "do-not-generate": "No generar",
                },
            },
            declineToVotePolicy: {
                label: "Política de abstención de voto",
                options: {
                    enabled: "Habilitado",
                    disabled: "Deshabilitado",
                },
            },
            blankBallotsPolicy: {
                label: "Política de papeletas en blanco",
                options: {
                    enabled: "Habilitado",
                    disabled: "Deshabilitado",
                },
            },
            votingScreenBackPolicy: {
                label: "Política del botón Atrás de la pantalla de votación",
                options: {
                    "election-selection-screen": "Ir a la pantalla de selección de elecciones",
                    "start-screen": "Ir a la pantalla de inicio de la elección",
                },
            },
        },
        tenantScreen: {
            common: {
                title: "Inquilinos",
            },
            new: {
                subtitle: "Crear nuevo inquilino",
            },
            createSuccess: "Inquilino creado",
            createError: "Error al crear el inquilino",
        },
        usersAndRolesScreen: {
            noPermissions: "No tienes permiso para acceder a los usuarios o roles.",
            common: {
                title: "Usuarios y Roles",
                subtitle: "Configuración general",
                mobileNumber: "Móvil",
            },
            editPassword: {
                passwordPolicyViolation: "La contraseña no cumple la Política de contraseñas de este evento electoral. Revise la política en Datos del evento electoral e introduzca una contraseña válida.",
                passwordPolicyRules: {
                    minimumLength: "La longitud mínima de la contraseña es {{count}}.",
                    maximumLength: "La longitud máxima de la contraseña es {{count}}.",
                    uppercase: "Caracteres en mayúscula requeridos: {{count}}.",
                    lowercase: "Caracteres en minúscula requeridos: {{count}}.",
                    digits: "Dígitos requeridos: {{count}}.",
                    specialCharacters: "Caracteres especiales requeridos: {{count}}.",
                },
                label: "Cambiar contraseña",
                temporatyLabel: "Temporal",
                temporatyInfo: "Si está habilitado, el usuario deberá cambiar la contraseña en el próximo inicio de sesión.",
            },
            users: {
                title: "Usuarios",
                subtitle: "Ver y editar datos del usuario",
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizaciones antes de enviarlas.",
                    confirm: "Confirmar cambios",
                    noChanges: "No hay cambios que revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Valor nuevo",
                },
                edit: {
                    title: "Información de Usuario",
                    subtitle: "Ver y editar Usuario",
                },
                create: {
                    title: "Usuario",
                    subtitle: "Crear usuario",
                },
                fields: {
                    "has_voted": "Voted",
                    "support_materials_viewed": "Support Materials Viewed",
                    "vote-weight": "Peso del voto",
                    "voted-channel": "Canal de voto",
                    "disable-comment": "Comentario de deshabilitación",
                    "username": "Nombre de Usuario",
                    "first_name": "Nombre",
                    "last_name": "Apellido",
                    "email": "Email",
                    "enabled": "Habilitado",
                    "emailVerified": "Email Verificado",
                    "groups": "Grupos",
                    "attributes": "Atributos",
                    "area": "Área",
                    "password": "Contraseña",
                    "savePassword": "Guardar contraseña",
                    "repeatPassword": "Repetir Contraseña",
                    "passwordMismatch": "Las contraseñas deben de coincidir",
                    "passwordLengthValidate": "La contraseña debe tener al menos 8 caracteres",
                    "passwordUppercaseValidate": "La contraseña debe contener al menos una letra mayúscula",
                    "passwordLowercaseValidate": "La contraseña debe contener al menos una letra minúscula",
                    "passwordDigitValidate": "La contraseña debe contener al menos un dígito",
                    "passwordSpecialCharValidate": "La contraseña debe contener al menos un carácter especial",
                    "trustee": "Actuar como fideicomisario",
                    "permissionLabel": "Etiqueta de permiso",
                    "authorized-election-ids": "Elecciones",
                },
                delete: {
                    body: "¿Estás seguro que quieres borrar este usuario?",
                    bulkBody: "¿Estás seguro que quieres borrar los usuarios seleccionados?",
                    bulkBodySelected: "Delete the {{count}} selected users? This cannot be undone.",
                    bulkBodyChoose: "{{count}} users are selected. You can instead delete every user matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error al exportar usuarios",
                    deleteError: "Error borrando usuario",
                    deleteSuccess: "Usuario borrado",
                    multipleDeleteSuccess: "Usuarios borrados",
                },
            },
            voters: {
                voterInformationLetter: {
                    label: "Carta de información para el votante",
                    generate: "Generar",
                    confirmation: "¿Generar una Carta de información para este votante? Se asignará una nueva contraseña y se incluirá en un PDF cifrado.",
                    generationStarted: "Se inició la generación de la Carta de información",
                    generationError: "No se pudo generar la Carta de información",
                    policyNotConfigured: "La Política de contraseñas no está configurada. Configúrela en Datos del evento electoral antes de generar una carta.",
                    policyMinimumLengthMissing: "La Política de contraseñas debe incluir una longitud mínima antes de generar una carta.",
                    policyCharacterClassMissing: "La Política de contraseñas debe incluir al menos una clase de caracteres antes de generar una carta.",
                },
                title: "Votantes",
                subtitle: "Ver y editar datos del votante",
                secretAttribute: {
                    storedPlaceholder: "Valor cifrado almacenado",
                    reveal: "Mostrar",
                    hide: "Ocultar",
                    revealError: "No se pudo mostrar el campo cifrado del votante",
                    includeInExport: "Incluir campos secretos descifrados del votante",
                    exportWarning: "Exportación sensible: el CSV descargado contendrá estos campos en texto plano.",
                    clear: "Borrar",
                    add: "Añadir valor",
                    remove: "Eliminar valor",
                },
                review: {
                    title: "Revisar cambios",
                    subtitle: "Confirma estas actualizaciones antes de enviarlas.",
                    confirm: "Confirmar cambios",
                    noChanges: "No hay cambios que revisar",
                    field: "Campo",
                    currentValue: "Valor actual",
                    newValue: "Valor nuevo",
                },
                logs: {
                    label: "Registros del usuario",
                },
                emptyHeader: "Ningún votante aún.",
                askCreate: "¿Quieres crear uno?",
                create: {
                    title: "Votante",
                    subtitle: "Crear votante",
                },
                manualVerification: {
                    label: "Verificar manualmente",
                    verify: "Verificar manualmente al votante",
                    body: "Verifique manualmente a este votante. Obtendrá un PDF con un enlace de código QR que le permite al votante iniciar sesión omitiendo el KYC en línea.",
                    noEmailOrPhone: "Este votante no puede ser verificado manualmente porque no tiene una dirección de correo electrónico o un número de teléfono asociado a él.",
                },
                errors: {
                    editError: "Error editando votante",
                    editErrorReason: "Error editando votante: {{reason}}",
                    editSuccess: "Votante editado",
                    createError: "Error creando votante",
                    createErrorReason: "Error creando votante: {{reason}}",
                    createSuccess: "Votante creado",
                    attribute: {
                        invalidNamed: 'Se rechazó "{{field}}": {{constraint}}',
                        fieldsToCorrect: "Algunos campos deben corregirse antes de guardar",
                        hintBetween: "Entre {{min}} y {{max}} caracteres",
                        hintMin: "Al menos {{min}} caracteres",
                        hintMax: "Como máximo {{max}} caracteres",
                        andMore: "y {{count}} más",
                        invalidLength: '"{{field}}" debe tener entre {{min}} y {{max}} caracteres',
                        tooShort: '"{{field}}" debe tener al menos {{min}} caracteres',
                        tooLong: '"{{field}}" debe tener como máximo {{max}} caracteres',
                        required: '"{{field}}" es obligatorio',
                        invalidEmail: '"{{field}}" debe ser una dirección de correo electrónico válida',
                        invalidFormat: '"{{field}}" no tiene el formato esperado',
                        invalid: '"{{field}}" tiene un valor no válido',
                    },
                    createPasswordError: "Votante creado, pero no se pudo establecer su contraseña",
                    createPasswordErrorReason: "Votante creado, pero no se pudo establecer su contraseña: {{reason}}",
                },
                delete: {
                    body: "¿Estás seguro que quieres borrar este votante?",
                    bulkBody: "¿Estás seguro que quieres borrar los votantes seleccionados?",
                    bulkBodySelected: "Delete the {{count}} selected voters? This cannot be undone.",
                    bulkBodyChoose: "{{count}} voters are selected. You can instead delete every voter matching the current filters, which may be more. This cannot be undone.",
                    okSelected: "Delete {{count}} selected",
                    okAllMatching: "Delete all matching",
                },
                notifications: {
                    exportError: "Error al exportar votantes",
                    deleteError: "Error borrando votante",
                    deleteSuccess: "Votante borrado",
                    multipleDeleteSuccess: "Votantes borrado",
                    manualVerificationError: "Error verificando manualmente al votante",
                    manualVerificationSuccess: "Verificado exitosamente manualmente al elector, descargar PDF..",
                },
            },
            roles: {
                title: "Roles",
                edit: {
                    title: "Información de Rol",
                    subtitle: "Ver y editar Rol",
                },
                create: {
                    title: "Rol",
                    subtitle: "Crear rol",
                },
                errors: {
                    createError: "Error creando rol",
                    createSuccess: "Rol creado",
                },
                fields: {
                    name: "Nombre",
                },
                delete: {
                    body: "¿Estás seguro que quieres borrar este rol?",
                },
                notifications: {
                    deleteError: "Error borrando rol",
                    deleteSuccess: "Rol borrado",
                    permissionEditError: "Error editando permiso",
                    permissionEditSuccess: "Permiso editado",
                },
            },
            permissions: {
                "voter-information-letter": "Generar Carta de información para el votante",
                "admin-user": "Administración",
                "admin-dashboard-view": "Vista del Panel de Administración",
                "application-export": "Exportación de Aplicaciones",
                "application-import": "Importación de Aplicaciones",
                "tenant-create": "Crear Inquilino",
                "tenant-read": "Leer Inquilino",
                "tenant-write": "Editar Inquilino",
                "tenant-delete": "Eliminar Inquilino",
                "election-event-create": "Crear Evento Electoral",
                "election-event-read": "Leer Evento Electoral",
                "election-event-write": "Editar Evento Electoral",
                "keycloak-realm-attributes-read": "Read Keycloak realm attributes",
                "keycloak-realm-attributes-write": "Edit Keycloak realm attributes",
                "election-event-delete": "Eliminar Evento Electoral",
                "voter-create": "Crear Votante",
                "voter-read": "Leer Votante",
                "voter-write": "Editar Votante",
                "voter-secret-attribute-read": "Mostrar Campos Secretos del Votante",
                "voter-secret-attribute-write": "Editar Campos Secretos del Votante",
                "user-create": "Crear Usuario",
                "user-read": "Leer Usuario",
                "user-write": "Editar Usuario",
                "user-permission-create": "Crear Permiso de Usuario",
                "user-permission-read": "Leer Permiso de Usuario",
                "user-permission-write": "Editar Permiso de Usuario",
                "role-create": "Crear Rol",
                "role-read": "Leer Rol",
                "role-write": "Editar Rol",
                "role-assign": "Asignar Rol",
                "communication-template-create": "Crear Plantilla de Comunicación",
                "communication-template-read": "Leer Plantilla de Comunicación",
                "communication-template-write": "Editar Plantilla de Comunicación",
                "notification-read": "Leer Notificación",
                "notification-write": "Editar Notificación",
                "notification-send": "Enviar Notificación",
                "area-read": "Leer Área",
                "area-write": "Editar Área",
                "election-state-write": "Editar Estado de Elección",
                "election-type-create": "Crear Tipo de Elección",
                "election-type-read": "Leer Tipo de Elección",
                "election-type-write": "Editar Tipo de Elección",
                "voting-channel-read": "Leer Canal de Votación",
                "voting-channel-write": "Editar Canal de Votación",
                "trustee-create": "Crear Fideicomisario",
                "trustee-read": "Leer Fideicomisario",
                "trustee-write": "Editar Fideicomisario",
                "tally-read": "Leer Recuento",
                "tally-start": "Iniciar Recuento",
                "tally-write": "Editar Recuento",
                "tally-results-read": "Leer Resultados de Recuento",
                "publish-read": "Leer Publicación",
                "publish-write": "Editar Publicación",
                "publish-results-read": "Leer Publicación de Resultados",
                "publish-results-write": "Editar Publicación de Resultados",
                "logs-read": "Leer Registros",
                "tasks-read": "Leer la Ejecución de Tareas",
                "keys-read": "Leer Claves",
                "document-upload": "Subir Documentos",
                "document-download": "Descargar Documentos",
                "document-password-read": "Leer contraseñas de documentos",
                "tally-sheet-create": "Crear Acta de Recuento",
                "tally-sheet-import-create": "Crear importación de actas de recuento",
                "tally-sheet-import-review": "Revisar importación de actas de recuento",
                "tally-sheet-import-view": "Ver importación de actas de recuento",
                "tally-recount-execute": "Ejecutar recuento de resultados",
                "trustee-ceremony": "Ceremonia de Fideicomisario",
                "tally-sheet-review": "Revisar hoja de recuento",
                "tally-sheet-view": "Ver Acta de Recuento",
                "admin-ceremony": "Administrar Ceremonia de Claves",
                "tally-sheet-delete": "Borrar Acta de Recuento",
                "cast-vote-read": "Leer Votos Emitidos",
                "document-read": "Leer Documentos",
                "document-write": "Editar Documentos",
                "support-material-read": "Leer Materiales de Soporte",
                "support-material-write": "Editar Materiales de Soporte",
                "miru-create": "Miru Create",
                "miru-download": "Miru Download",
                "miru-send": "Miru Send",
                "miru-sign": "Miru Sign",
                "contest-write": "Editar Concurso",
                "contest-read": "Leer Concurso",
                "candidate-write": "Editar Candidatos",
                "candidate-read": "Leer Candidatos",
                "permission-label-write": "Editar la etiqueta de permiso",
                "scheduled-event-write": "Editar Eventos Programados",
                "contest-create": "Create Contest",
                "contest-delete": "Delete Contest",
                "candidate-create": "Create Candidate",
                "candidate-delete": "Delete Candidate",
                "election-create": "Create Election",
                "election-read": "Read Election",
                "election-write": "Edit Election",
                "election-delete": "Delete Election",
                "election-event-archive": "Archive Election Event",
                "election-data-tab": "Ver Datos de la Elección",
                "election-event-areas-tab": "Ver Áreas del Evento Electoral",
                "election-event-data-tab": "Ver Datos del Evento Electoral",
                "election-event-keys-tab": "Ver Claves del Evento Electoral",
                "election-event-logs-tab": "Ver Registros del Evento Electoral",
                "election-event-publish-tab": "Ver Publicación del Evento Electoral",
                "election-event-reports-tab": "Ver Informes del Evento Electoral",
                "election-event-scheduled-tab": "Ver Programación del Evento Electoral",
                "election-event-tally-tab": "Ver Escrutinio del Evento Electoral",
                "election-event-tasks-tab": "Ver Tareas del Evento Electoral",
                "election-event-voters-tab": "Ver Votantes del Evento Electoral",
                "election-publish-tab": "Ver Publicación de la Elección",
                "election-voters-tab": "Ver Votantes de la Elección",
                "report-write": "Editar Informes",
                "report-read": "Leer Informes",
                "users-menu": "Ver usuarios y roles",
                "settings-menu": "Ver configuración",
                "templates-menu": "Ver plantillas",
                "settings-election-types-tab": "Ver configuración de tipos de elección",
                "settings-voting-channels-tab": "Ver configuración de canales de votación",
                "settings-templates-tab": "Ver configuración de plantillas",
                "settings-languages-tab": "Ver configuración de idiomas",
                "settings-localization-tab": "Ver configuración de localización",
                "settings-look-feel-tab": "Ver configuración de apariencia",
                "settings-trustees-tab": "Ver configuración de fideicomisarios",
                "settings-countries-tab": "Ver configuración de países",
                "voter-import": "Importar Votante",
                "ee-voters-columns": "Ver Columnas de Votantes del Evento Electoral",
                "voter-manually-verify": "Verificar Votante Manualmente",
                "ee-voters-logs": "Ver Registros de Votantes del Evento Electoral",
                "voter-export": "Exportar Votante",
                "ee-voters-filters": "Ver Filtros de Votantes del Evento Electoral",
                "voter-delete": "Eliminar Votante",
                "voter-change-password": "Cambiar la Contraseña del Votante",
                "election-event-localization-selector": "Selector de Localización del Evento Electoral",
                "localization-create": "Crear Localización",
                "localization-read": "Leer Localización",
                "localization-write": "Editar Localización",
                "localization-delete": "Eliminar Localización",
                "area-create": "Crear Área",
                "area-delete": "Eliminar Área",
                "area-export": "Exportar Área",
                "area-import": "Importar Área",
                "area-upsert": "Insertar o Actualizar Área",
                "election-event-areas-columns": "Columnas de las Áreas del Evento Electoral",
                "election-event-areas-filters": "Filtros de las Áreas del Evento Electoral",
                "election-event-tasks-back-button": "Volver a las Tareas del Evento Electoral",
                "election-event-tasks-columns": "Columnas de las Tareas del Evento Electoral",
                "election-event-tasks-filters": "Filtros de las Tareas del Evento Electoral",
                "task-export": "Exportar Tareas",
                "application-read": "Leer Aplicación",
                "application-write": "Editar Aplicación",
                "logs-export": "Exportar Registros",
                "election-event-logs-columns": "Columnas de los Registros del Evento Electoral",
                "election-events-logs-filters": "Filtros de los Registros del Evento Electoral",
                "election-event-scheduled-event-columns": "Columnas de los Eventos Programados del Evento Electoral",
                "scheduled-event-create": "Crear Evento Programado",
                "scheduled-event-delete": "Eliminar Evento Programado",
                "election-event-reports-columns": "Columnas de los Informes del Evento Electoral",
                "report-create": "Crear Informe",
                "report-delete": "Eliminar Informe",
                "report-generate": "Generar Informe",
                "report-preview": "Vista Previa del Informe",
                "monitor-authenticated-voters": "Monitoreo de Votantes Autenticados",
                "monitor-all-approve-disapprove-voters": "Leer Monitoreo de Votantes Aprobados y Rechazados",
                "monitor-automatic-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Automáticos",
                "monitor-manually-approve-disapprove-voters": "Leer Monitoreo de Aprobaciones y Rechazos Manuales",
                "monitor-enrolled-overseas-voters": "Leer Monitoreo de Votantes Inscritos en el Extranjero",
                "monitor-posts-already-closed-voting": "Leer Monitoreo de Publicaciones con Votación Cerrada",
                "monitor-posts-already-generated-election-results": "Leer Monitoreo de Publicaciones con Resultados Generados",
                "monitor-posts-already-opened-voting": "Leer Monitoreo de Publicaciones con Votación Abierta",
                "monitor-posts-already-started-counting-votes": "Leer Monitoreo de Publicaciones que Comenzaron a Contar Votos",
                "monitor-posts-initialized-the-system": "Leer Monitoreo de Publicaciones que Inicializaron el Sistema",
                "monitor-posts-started-voting": "Leer Monitoreo de Publicaciones que Comenzaron a Votar",
                "monitor-posts-transmitted-results": "Leer Monitoreo de Publicaciones que Transmitieron Resultados",
                "monitor-voters-voted-test-election": "Leer Monitoreo de Votantes en Elección de Prueba",
                "monitor-voters-who-voted": "Leer Monitoreo de Votantes que Votaron",
                "election-event-publish-preview": "Vista Previa de la Publicación del Evento Electoral",
                "election-event-publish-back-button": "Volver a la Publicación del Evento Electoral",
                "election-event-publish-columns": "Columnas de la Publicación del Evento Electoral",
                "election-event-publish-filters": "Filtros de la Publicación del Evento Electoral",
                "publish-create": "Crear Publicación",
                "publish-regenerate": "Regenerar Publicación",
                "publish-export": "Exportar Publicación",
                "publish-start-voting": "Iniciar Votación",
                "publish-pause-voting": "Pausar Votación",
                "publish-stop-voting": "Detener Votación",
                "publish-changes": "Publicar Cambios",
                "election-event-publish-view": "Ver Publicación del Evento Electoral",
                "election-event-keys-columns": "Columnas de las Claves del Evento Electoral",
                "create-ceremony": "Crear Ceremonia",
                "export-ceremony": "Exportar Ceremonia",
                "election-event-tally-columns": "Columnas del Recuento del Evento Electoral",
                "election-event-tally-back-button": "Volver al Recuento del Evento Electoral",
                "transmition-ceremony": "Ceremonia de Transmisión",
                "admin-ip-address-view": "Ver Dirección IP",
                "election-approvals-tab": "Ver Aprobaciones de la Elección",
                "election-event-approvals-tab": "Ver Aprobaciones del Evento Electoral",
                "election-ip-address-view": "Ver Dirección IP de la Elección",
                "election-dashboard-tab": "Ver Dashboard de la Elección",
                "trustees-export": "Exportar Fideicomisarios",
                "user-import": "Importar Usuarios",
                "voter-voted-edit": "Editar a los votantes que votaron",
                "voter-email-tlf-edit": "Editar email/teléfono de los votantes",
                "cloudflare-write": "Editar las reglas de bloqueo por país en Cloudflare",
                "transmission-report-generate": "Generar Informe de Transmisión",
                "google-meet-link": "Generar Enlace de Google Meet",
                "service-account": "Cuenta de servicio",
                "datafix-account": "Cuenta de corrección de datos",
                "gold": "Oro",
                "silver": "Plata",
                "election-event-ivr-tab": "Ver IVR del evento electoral",
                "election-event-cas-tab": "Ver CAS del evento electoral",
                "ca-read": "Consultar autoridades de certificación",
                "ca-write": "Editar autoridades de certificación",
                "generate-preview": "Generar vista previa",
                "preview-read": "Consultar vista previa",
                "tally-resolution-submit": "Enviar resolución del escrutinio",
                "phone-blacklist-read": "Consultar lista negra de teléfonos",
                "phone-blacklist-create": "Crear entradas en la lista negra de teléfonos",
                "phone-blacklist-update": "Editar entradas de la lista negra de teléfonos",
                "phone-blacklist-delete": "Eliminar entradas de la lista negra de teléfonos",
                "election-event-voter-list-reconciliation": "Conciliar la lista de votantes del evento electoral",
            },
        },
        generalSettingsScreen: {
            body: "Active los idiomas en el sistema. Solo los idiomas activados aquí estarán disponibles para eventos electorales.",
        },
        eventsScreen: {
            title: "Eventos Programados",
            subtitle: "Gestiona la configuración de la ejecución automática de eventos como el inicio o fin del período de votación.",
            messages: {
                createSuccess: "Evento Programado creado con éxito",
                createError: "Error al crear el Evento Programado",
                editSuccess: "Evento Programado editado con éxito",
                editError: "Error al editar el Evento Programado",
            },
            eventType: {
                label: "Tipo",
                ALLOW_INIT_REPORT: "Allow Initialization Report",
                START_VOTING_PERIOD: "Inicio del Período de Votación",
                END_VOTING_PERIOD: "Fin del Período de Votación",
                ALLOW_VOTING_PERIOD_END: "Allow Voting Period End",
                START_ENROLLMENT_PERIOD: "Inicio del Período de Inscripción",
                END_ENROLLMENT_PERIOD: "Fin del Período de Inscripción",
                START_LOCKDOWN_PERIOD: "Inicio del Período de Bloqueo de Datos Censales",
                END_LOCKDOWN_PERIOD: "Fin del Período de Bloqueo de Datos Censales",
                ALLOW_TALLY: "Permitir Recuento",
            },
            election: {
                label: "Elección",
            },
            empty: {
                header: "No hay Eventos Programados todavía.",
                body: "¿Quieres crear uno?",
                button: "Crear Evento Programado",
            },
            create: {
                title: "Crear Evento Programado",
                subtitle: "Crea una nueva configuración de Evento Programado.",
            },
            edit: {
                title: "Editar Evento Programado",
                subtitle: "Edita la configuración del Evento Programado.",
                delete: "¿Estás seguro de que quieres eliminar este Evento Programado?",
            },
            fields: {
                electionId: "Elección",
                eventProcessor: "Tipo",
                stoppedAt: "Detenido En",
                scheduledDate: "Programado En",
            },
        },
        reportsScreen: {
            title: "Informes",
            subtitle: "Generar informes para los eventos electorales",
            messages: {
                createSuccess: "Informe creado con éxito",
                createError: "Error al crear el informe",
                submitError: "Error al enviar el Informe",
                updateSuccess: "Informe actualizado con éxito",
                passwordMismatch: "Las contraseñas no coinciden. Asegúrate de que ambos campos contengan la misma contraseña.",
                incorectPassword: "Contraseña incorrecta",
                decryptFileTitle: "Descifrar archivo",
                decryptInstructions: "1. '-in': La ruta al archivo cifrado. \n2. '-out': La ruta donde se guardará el archivo descifrado. \n3. '-pass': La contraseña utilizada para cifrar el archivo. \n",
                encryptSuccess: "Configuración de cifrado del informe exitosa",
                encryptError: "Error al configurar el cifrado del informe",
            },
            reportType: {
                BALLOT_RECEIPT: "Recibo de Voto",
                ELECTORAL_RESULTS: "Resultados Electorales",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
                STATISTICAL_REPORT: "Informe Estadístico",
                OVCS_EVENTS: "Monitoreo de Votación en el Extranjero - Eventos OVCS",
                AUDIT_LOGS: "Registros de Auditoría",
                ACTIVITY_LOG: "Registros de Actividad",
                STATUS: "Estado",
                OVCS_INFORMATION: "Información de OVCS",
                OVERSEAS_VOTERS: "Lista de Votantes en el Extranjero",
                OV_USERS_WHO_VOTED: "Lista de Votantes en el Extranjero que Votaron",
                OV_WITH_VOTING_STATUS: "Lista de Votantes en el Extranjero con Estado de Votación",
                OVCS_STATISTICS: "Monitoreo de Votación en el Extranjero - Estadísticas OVCS",
                PRE_ENROLLED_OV_BUT_DISAPPROVED: "Lista de Votantes en el Extranjero que se Preinscribieron pero Fueron Rechazados",
                PRE_ENROLLED_OV_SUBJECT_TO_MANUAL_VALIDATION: "Lista de Votantes en el Extranjero que se Preinscribieron pero Requieren Validación Manual",
            },
            reportEncryptionPolicy: {
                title: "Política de cifrado",
                UNENCRYPTED: "Sin cifrar",
                CONFIGURED_PASSWORD: "Contraseña configurada",
            },
            empty: {
                header: "No hay informes todavía.",
                body: "¿Quieres crear uno?",
                button: "Crear informe",
            },
            create: {
                title: "Crear informe",
                subtitle: "Crear una nueva configuración de informe.",
            },
            edit: {
                title: "Editar informe",
                subtitle: "Editar configuración del informe.",
                delete: "¿Estás seguro de que quieres eliminar este informe?",
            },
            fields: {
                electionId: "Elección",
                template: "Plantilla",
                reportType: "Tipo de informe",
                repeatable: "Repetible",
                cronExpression: "Expresión Cron",
                emailRecipients: "Destinatarios de correo electrónico",
                emailRecipientsPlaceholder: "Escribe el correo electrónico y presiona Enter",
            },
            delete: {
                body: "¿Estás seguro de que quieres eliminar este informe?",
            },
            actions: {
                generate: "Generar",
                delete: "Eliminar",
                edit: "Editar",
                preview: "Vista previa",
            },
        },
        googleMeet: {
            title: "Generar Enlace de Google Meet",
            generateButton: "Google Meet",
            meetingTitle: "Título de la Reunión",
            description: "Descripción (Opcional)",
            startDate: "Fecha de Inicio",
            startTime: "Hora de Inicio",
            duration: "Duración (minutos)",
            attendeeEmails: "Emails de los Participantes",
            attendeeEmailHelp: "Emails separados por comas para los participantes de la reunión",
            note: "Nota: Esto creará un evento de calendario en tu Google Calendar con un enlace de Google Meet. Necesitarás iniciar sesión en tu cuenta de Google.",
            success: "¡Enlace de Google Meet Generado Exitosamente!",
            copy: "Copiar al portapapeles",
            copied: "¡Enlace copiado al portapapeles!",
            instructions: "Comparte este enlace con los participantes para unirse a la reunión. El evento de calendario ha sido añadido a tu Google Calendar.",
            generating: "Generando...",
            generate: "Generar Enlace de Meet",
        },
        common: {
            export: "La exportación puede ser un proceso largo. ¿Estás seguro que quieres exportar?",
            resources: {
                electionEvent: "Evento Electoral",
                election: "Elección",
                contest: "Concurso",
                candidate: "Candidato",
                noResult: {
                    askCreate: "¿Quieres crear una?",
                },
            },
            label: {
                add: "Añadir",
                actions: "Acciones",
                create: "Crear",
                delete: "Borrar",
                archive: "Archivar",
                unarchive: "Desarchivar",
                cancel: "Cancelar",
                edit: "Editar",
                yes: "Sí",
                no: "No",
                save: "Guardar",
                close: "Cerrar",
                back: "Atrás",
                next: "Siguiente",
                warning: "Aviso",
                json: "Vista previa",
                noResult: "Sin resultados",
                import: "Importar",
                export: "Exportar",
                loadingData: "Cargando datos ...",
                exportFormat: "Exportar en formato {{format}} - Resultados de '{{item}}'",
                allResults: "del evento electoral",
                globalAreaResults: "de todas las áreas",
                title: "Título",
                subtitle: "Subtítulo",
                kind: "Tipo de archivo",
                filter: "Filtros Personalizados",
                approve: "Aprobar",
                continue: "Continuar",
                logout: "Cerrar Sesión",
                selectTenant: "Seleccionar Inquilino",
                processing: "Procesando...",
                tenantName: "Nombre del Inquilino",
            },
            language: {
                es: "Español",
                en: "Inglés",
                fr: "Francés",
                cat: "Valenciano",
                tl: "Tagalo",
                gl: "Galego",
                nl: "Holandes",
                eu: "Euskera",
            },
            channel: {
                online: "En línea",
                kiosk: "Kiosco",
                early_voting: "Votación anticipada",
                telephone: "Votación telefónica",
                other: "Otros",
            },
            message: {
                delete: "¿Estás seguro que quieres borrar este elemento?",
                continueOrLogout: "¿Quieres continuar o cerrar sesión?",
            },
        },
        createResource: {
            electionEvent: "Crear un Evento Electoral",
            election: "Crear una Elección",
            contest: "Crear un Concurso",
            candidate: "Crear un Candidato",
        },
        importResource: {
            electionEvent: "Importar un Evento Electoral",
            election: "Importar una Elección",
            contest: "Importar un Concurso",
            candidate: "Importar un Candidato",
            ImportHashMismatch: "Hashes don't match. Integrity check failure.",
        },
        sideMenu: {
            electionEvents: "Procesos Electorales",
            search: "Buscar",
            usersAndRoles: "Usuarios y Roles",
            logs: "Bitácora",
            settings: "Configuracion",
            help: "Ayuda",
            templates: "Plantillas",
            active: "Activos",
            archived: "Archivados",
            addResource: {
                electionEvent: "Crear un Evento Electoral",
                election: "Crear una Elección",
                contest: "Crear un Concurso",
                candidate: "Crear un Candidato",
            },
            menuActions: {
                archive: {
                    electionEvent: "Archivar este Evento Electoral",
                },
                unarchive: {
                    electionEvent: "Desarchivar este Evento Electoral",
                    election: "Desarchivar esta Elección",
                    contest: "Desarchivar este Concurso",
                    candidate: "Desarchivar este Candidato",
                },
                remove: {
                    electionEvent: "Eliminar este Evento Electoral",
                    election: "Eliminar esta Elección",
                    contest: "Eliminar este Concurso",
                    candidate: "Eliminar este Candidato",
                },
                messages: {
                    confirm: {
                        archive: "¿Está seguro de que desea archivar este elemento?",
                        unarchive: "¿Está seguro de que desea desarchivar este elemento?",
                        delete: "¿Está seguro de que desea eliminar este elemento?",
                    },
                    notification: {
                        success: {
                            archive: "El elemento ha sido archivado",
                            unarchive: "El elemento ha sido desarchivado",
                            delete: "El elemento ha sido eliminado",
                            reloading: "Espere. La página se recargara en unos momentos",
                        },
                        error: {
                            archive: "Error al intentar archivar este elemento",
                            unarchive: "Error al intentar desarchivar este elemento",
                            delete: "Error al intentar eliminar este elemento",
                        },
                    },
                },
            },
        },
        candidateScreen: {
            common: {
                subtitle: "Configuración de candidatos.",
            },
            edit: {
                externalId: "ID externo",
                general: "General",
                type: "Tipo",
                image: "Imagen",
                isDisabled: "Deshabilitado",
                isExplicitInvalid: "Voto Inválido",
                isExplicitBlank: "Voto en Blanco",
                isCategoryList: "Lista",
                isWriteIn: "Voto por Escrito",
            },
            field: {
                name: "Nombre",
                alias: "Alias",
                description: "Descripción",
            },
            options: {
                "candidate": "Candidato",
                "option": "Opción",
                "write-in": "Voto por Escrito",
                "open-list": "Lista Abierta",
                "closed-list": "Lista Cerrada",
                "semi-open-list": "Lista Semiabierta",
                "invalid-vote": "Voto Inválido",
                "blank-vote": "Voto en Blanco",
            },
            invalidVotePosition: {
                label: "Posición del Voto Inválido",
                null: "Ninguno (Por defecto)",
                top: "Arriba",
                bottom: "Abajo",
            },
            error: {},
            createCandidateSuccess: "Candidato creado",
            createCandidateError: "Error creating candidato",
        },
        contestScreen: {
            common: {
                subtitle: "Configuración de pregunta.",
            },
            edit: {
                externalId: "ID externo",
                general: "General",
                type: "Tipo",
                image: "Imagen",
                system: "Sistema de votación de papeletas",
                design: "Diseño de la papeleta",
                reorder: "Reordernar candidatos",
                policies: "Políticas",
            },
            field: {
                name: "Nombre",
                alias: "Alias",
                description: "Descripción",
            },
            options: {
                "non-preferential": "Sin Preferencia",
                "plurality-at-large": "Mayoría Plural",
                "instant-runoff": "Segunda Vuelta Instantánea",
                "random": "Aleatorias",
                "external-procedure": "Procedimiento externo",
                "custom": "Personalizado",
                "alphabetical": "Alfabético",
            },
            tieBreakingPolicy: {
                label: "Política de desempate",
            },
            auditButtonConfig: {
                "label": "Opciones de visualización del botón de auditoría",
                "show": "Mostrar",
                "not-show": "No mostrar",
                "show-in-help": "Mostrar en el cuadro de diálogo de ayuda",
            },
            underVotePolicy: {
                "label": "Política de Subvoto",
                "allowed": "Permitido",
                "warn-only-in-review": "Advertir en Revisión",
                "warn": "Advertir",
                "warn-and-alert": "Advertir y Alertar",
            },
            invalidVotePolicy: {
                "label": "Política de Voto Inválido",
                "allowed": "Permitido",
                "warn": "Advertencia",
                "warn-invalid-implicit-and-explicit": "Advertir Inválidos Implícitos y Explícitos",
                "not-allowed": "No Permitido",
                "allowed-with-exclusive-explicit": "Permitido con Voto Inválido Exclusivo",
            },
            candidatesIconCheckboxPolicy: {
                "label": "Forma del icono de la casilla de verificación de los candidatos",
                "square-checkbox": "Casilla de verificación cuadrada",
                "round-checkbox": "Casilla de verificación redonda",
            },
            checkableListPolicy: {
                "allow-selecting-candidates-and-lists": "Candidatos Y Listas",
                "allow-selecting-candidates": "Sólo Candidatos",
                "allow-selecting-lists": "Sólo Listas",
                "disabled": "Deshabilitado",
            },
            collapsibleListsPolicy: {
                "label": "Listas plegables",
                "disabled": "Deshabilitado",
                "enabled-expanded": "Habilitado (empieza expandido)",
                "enabled-collapsed": "Habilitado (empieza contraído)",
            },
            blankVotePolicy: {
                "label": "Política de voto en blanco",
                "allowed": "Permitido",
                "warn-only-in-review": "Advertir en Revisión",
                "warn": "Advertir",
                "not-allowed": "No permitido",
            },
            overVotePolicy: {
                "label": "Política de voto excesivo",
                "allowed": "Permitido",
                "allowed-with-msg": "Permitido con un mensaje de warning",
                "allowed-with-msg-and-alert": "Permitido con un mensaje de warning y alerta",
                "not-allowed-with-msg-and-alert": "No permitido con un mensaje de warning y alerta",
                "not-allowed-with-msg-and-disable": "No permitido con un mensaje de warning y dehabilitar selecciones adicionales",
            },
            duplicatedRankPolicy: {
                "label": "Voto inválido - Política de rango duplicado",
                "allowed-warn-and-dialog": "Mostrar advertencia y diálogo (el votante puede continuar)",
                "not-allowed-warn-and-dialog": "Mostrar advertencia y diálogo (el votante no puede continuar)",
            },
            preferenceGapsPolicy: {
                "label": "Voto inválido - Política de rangos omitidos",
                "allowed-warn-and-dialog": "Mostrar advertencia y diálogo (el votante puede continuar)",
                "not-allowed-warn-and-dialog": "Mostrar advertencia y diálogo (el votante no puede continuar)",
            },
            paginationPolicy: {
                label: "Nombre de la página",
            },
            isAcclaimed: {
                label: "Resuelto por aclamación",
                helperText: "Los votantes ven esta votación pero no pueden seleccionar nada, no se registra nada y todas las candidaturas se declaran ganadoras con cero votos. Configúrelo antes de publicar las papeletas: cambiarlo después invalida las papeletas ya emitidas.",
            },
            allowWriteins: {
                label: "Permitir candidaturas manuales",
            },
            maxVotes: {
                helperText: "Número máximo de candidatos que un votante puede seleccionar (votación no preferencial).",
                helperTextPreferential: "Posición de rango más alta disponible para los votantes (p.ej. '5' significa posiciones 1–5). Debe ser al menos igual al número de candidatos a ordenar (votación preferencial).",
            },
            error: {},
            createContestSuccess: "Pregunta creado",
            createContestError: "Error creando pregunta",
        },
        keysGeneration: {
            configureStep: {
                create: "Crear Ceremonia de Claves",
                name: "Nombre de la Ceremonia de Claves",
                allElections: "Todas las Elecciones",
                title: "Crear Ceremonia de Claves del Evento Electoral",
                subtitle: "En esta ceremonia cada autoridad generará y descargará su parte de las claves privadas para el Evento Electoral. Para continuar, elija los autoridades que participarán en la ceremonia y el umbral, que es el número mínimo de autoridades necesarios para contar.",
                trusteeList: "Autoridades",
                threshold: "Umbral",
                errorMinTrustees_one: "Seleccionaste sólo {{selected}} autoridad, pero debe seleccionar al menos {{threshold}}.",
                errorMinTrustees_other: "Seleccionaste sólo {{selected}} autoridades, pero debe seleccionar al menos {{threshold}}.",
                errorThreshold: "Seleccionaste un umbral de {{selected}} pero debe estar entre {{min}} y {{max}}.",
                errorCreatingCeremony: "Error creando Ceremonia de Claves: {{error}}",
                createCeremonySuccess: "Ceremonia de Claves creada",
                confirmdDialog: {
                    ok: "Sí, Crear Ceremonia de Claves",
                    cancel: "Cancelar",
                    title: "¿Estás seguro de que quieres Crear una Ceremonia de Claves?",
                    automaticCeremonyTitle: "¿Estás seguro de que quieres crear una ceremonia de llaves automática?",
                    description: "Estás a punto de Crear una Ceremonia de Claves. Esta acción notificará a las Autoridades para participar en la creación y distribución de las Claves del Evento Electoral.",
                    automaticCeremonyDescription: "Estás a punto de crear una ceremonia de llaves automática. Esto no notificará a los fideicomisarios para que participen.",
                },
                filterTrustees: "Filtrar Autoridades",
                errorPermisionLabels: "No se puede crear la ceremonia de claves: falta una o más etiquetas de permisos.",
                automaticCeremonyToggle: "Ceremonia automática",
            },
            ceremonyStep: {
                cancel: "Cancelar Ceremonia de Claves",
                progressHeader: "Progreso de Ceremonia de Claves",
                description: "Esta pantalla muestra el progreso y los registros de la Ceremonia de Claves del Evento Electoral. En la Ceremonia de Claves, cada autoridad generará y descargará su fragmento de la clave privada para el Evento Electoral.",
                executionStatus: "Estado: {{status}}",
                confirmdDialog: {
                    ok: "Sí, Cancelar Creación de Ceremonia de Claves",
                    cancel: "Volver a la Ceremonia de Claves",
                    title: "¿Estás seguro de que quieres Cancelar la Ceremonia de Claves?",
                    description: "Estás a punto de Cancelar la Ceremonia de Claves. Después de realizar esta acción, para tener una Ceremonia de Claves exitosa tendrás que Crear una nueva.",
                },
                header: {
                    trusteeName: "Nombre de Autoridad",
                    fragment: "Fragmento de Clave Generado",
                    downloaded: "Fragmento Privado de Clave Descargado",
                    checked: "Fragmento Privado de Clave Comprobado",
                },
                logsHeader: {
                    title: "Logs",
                    date: "Fecha",
                    entry: "Entrada",
                },
                emptyLogs: "Sin logs aún.",
            },
            startStep: {
                title: "Ceremonia de Claves de Autoridad",
                subtitle: "Estás a punto de participar en la Ceremonia de Claves como la Autoridad (<strong>{{name}}</strong>). Esto implica los siguientes pasos:",
                one: "<strong>Descargar</strong> tu Clave Privada Encriptada.",
                two: "Crear múltiples <strong>Copias de seguridad</strong> de tu Clave Privada Encriptada.",
                three: "<strong>Verificar</strong> que las copias de seguridad funcionan correctamente.",
            },
            downloadStep: {
                title: "Descargar Clave Privada Encriptada",
                subtitle: "Para continuar, por favor descarga y guarda tu Clave Privada Encriptada en al menos dos dispositivos diferentes:",
                downloadButton: "Descargar tu Clave Privada Encriptada",
                downloaded: "Clave Privada Encriptada descargada correctamente.",
                errorEmptyKey: "Error de descarga, fichero vacío",
                unexpectedError: "No se pudo descargar la clave privada. Inténtalo de nuevo.",
                alreadyVerified: "Tu clave privada ya se había descargado y verificado.",
                unavailable: "La descarga de la clave privada ya no está disponible porque la ceremonia ha avanzado.",
                confirmdDialog: {
                    ok: "Confirmar copias de seguridad y Continuar",
                    cancel: "Volver",
                    title: "Copia de seguridad de tu Clave Privada Encriptada",
                    description: "Por favor, realiza una copia de seguridad de tu Clave Privada Encriptada en al menos dos ubicaciones seguras diferentes y luego confírmalo a continuación:",
                    firstCopy: "Primera copia de seguridad realizada",
                    secondCopy: "Segunda copia de seguridad realizada",
                    confirmError: "Cree las copias de seguridad requeridas y marque las casillas de confirmación para continuar",
                },
            },
            checkStep: {
                title: "Verifica tus Copias de Seguridad de tu Clave Privada Encriptada",
                verifyButton: "Verificar clave",
                subtitle: "Sube la Copia de Seguridad de tu Clave Privada Encriptada para verificar que sea correcta. Puedes intentarlo tantas veces como sea necesario, desde tus diferentes copias de seguridad:",
                errorUploading: "Copa de Seguridad de la Clave Encriptada Privada inválida, por favor inténtalo de nuevo",
                errorEmptyFile: "Fichero vacío o no encontrado",
                verified: "Copia de seguridad verificada correctamente.",
                alreadyRestored: "Tu clave ya se había restaurado.",
            },
        },
        miruExport: {
            create: {
                success: "Paquete de Transmisión Creado",
                error: "Error al crear el Paquete de Transmisión",
            },
            send: {
                success: "Paquete de Transmisión Enviado",
                error: "Error al enviar el Paquete de Transmisión",
            },
        },
        tally: {
            errorUploadingSignature: "Hubo un error al subir la firma",
            downloadTransmissionPackage: "Descargar paquete",
            resultsPublication: {
                sectionTitle: "Publish to results website",
                policyTitle: "Results Website",
                policyAccess: "Results Website Access",
                policyVisibility: "Results Website Visibility",
                enabled: "Enabled",
                disabled: "Disabled",
                fullEvent: "Full event",
                areaBased: "Area based",
                publishStarted: "Results publication started",
                publishError: "Could not start results publication",
                revoked: "Results publication revoked",
                revokeError: "Could not revoke results publication",
                waitingForTally: "Results can be published after this tally has completed.",
                writePermissionRequired: "You need publish-results-write permission to publish or revoke results.",
                readPermissionRequired: "You need publish-results-read permission to view publication history.",
                disabledPolicy: "Results website publishing is disabled for this election event. Enable it in the election event data before publishing results.",
                loadingElectionContext: "Results publication is loading election context.",
                route: "Route",
                eventResults: "Event results",
                electionResults: "Election results",
                election: "Election",
                access: "Access",
                publicAccess: "Public access",
                authenticatedAccess: "Authenticated access",
                visibility: "Visibility",
                fullPublishedScope: "Full published scope",
                personalVisibility: "Personal visibility",
                contests: "Contests",
                noTalliedContests: "No tallied contests available.",
                publishSelectedContests: "Publish selected contests",
                selectedContestCount: "{{count}} contest selected",
                selectedContestCount_plural: "{{count}} contests selected",
                history: "Publication history",
                version: "Version",
                status: "Status",
                published: "Published",
                revokedAt: "Revoked",
                actions: "Actions",
                open: "Open",
                revoke: "Revoke",
                noPublications: "No publications yet.",
                confirmTitle: "Start publish to results website?",
                confirmDescription: "This will create a new publication from the current tally execution. The existing voter-facing results stay active until this publish task succeeds.",
                close: "Close",
            },
            transmissionPackage: {
                title: "Paquete de Transmisión para el Área '{{name}}' y Elección '{{eventName}}'",
                description: "Te permite exportar un Paquete de Transmisión a los Servidores de Destino o descargarlo.",
                actions: {
                    sign: {
                        title: "Regenerar",
                        dialog: {
                            title: "¿Desea firmar el paquete de transmisión?",
                            description: "Por favor, confirme que desea regenerar el paquete de transmisión para el área `{{name}}`",
                            confirm: "Firmar paquete de transmisión",
                            cancel: "Cerrar",
                            input: {
                                placeholder: "Ingrese su contraseña",
                            },
                        },
                    },
                    send: {
                        title: "Enviar",
                        dialog: {
                            title: "¿Quieres enviar el Paquete de Transmisión?",
                            description: "Por favor, confirma que deseas enviar el Paquete de Transmisión para el Área '{{name}}' a los Servidores de Destino.",
                            confirm: "Enviar Paquete de Transmisión",
                            cancel: "Cerrar",
                        },
                    },
                    regenerate: {
                        title: "Regenerar",
                        dialog: {
                            title: "¿Desea regenerar el paquete de transmisión?",
                            description: "Por favor confirme que desea regenerar el paquete de transmisión para el área `{{name}}`",
                            confirm: "Regenerar paquete de transmisión",
                            cancel: "Cerrar",
                        },
                    },
                    download: {
                        title: "Descargar",
                        emlTitle: "Download EML {{date}}",
                        transmissionPackageTitle: "Descargar el Paquete de Transmisión {{date}}",
                        transmissionReportTitle: "Descargar informe de transmisión",
                        dialog: {
                            title: "¿Quieres descargar el Paquete de Transmisión?",
                            description: "Por favor, confirma que deseas descargar el Paquete de Transmisión para el Área '{{name}}.'",
                            confirm: "Descargar Paquete de Transmisión",
                            cancel: "Cerrar",
                        },
                    },
                },
                destinationServers: {
                    title: "Servidores de Destino",
                    description: "La tabla a continuación muestra el estado de envío de cada uno de los Servidores de Destino.",
                    status: "Enviado a {{signed}} de {{total}}",
                    table: {
                        serverName: "Nombre del Servidor",
                        sendStatus: "Estado de Envío",
                    },
                },
                signatures: {
                    title: "Firmas SBEI",
                    description: "Los SBEIs pueden firmar el Paquete de Transmisión. La tabla a continuación muestra el estado de la firma de cada uno de los miembros del SBEI.",
                    table: {
                        trusteeName: "Nombre del Fideicomisario",
                        signed: "Ha Firmado",
                    },
                    status: "{{signed}} de {{total}} Han Firmado",
                },
            },
            sendToTransmissionPackageServers: "Enviar paquete de transmisión para el área '{{name}}'",
            uploadTransmissionPackage: "Subir",
            uploadTransmissionPackageDesc: "Sube tu firma para firmar el paquete de Resultados Electorales. Esta operación es opcional.",
            exportElectionArea: "Enviar paquete de transmisión para el área '{{name}}'",
            generateReport: "Generar {{name}}",
            templateTitle: "Plantilla de Resultados",
            templateSubTitle: "Opcionalmente sobrescribir la plantilla de resultados.",
            keysCeremonyTitle: "Ceremonia de Llaves",
            keysCeremonySubTitle: "Selecciona la Ceremonia de Llaves para este recuento",
            ceremonyTitle: "Elecciones para el Recuento",
            initializationTitle: "Elecciones para el informe de inicialización",
            ceremonySubTitle: "Seleccione las elecciones para el recuento",
            tallyTitle: "Progreso del Recuento de Elecciones",
            logsTitle: "Logs",
            resultsTitle: "Resultados & Participación",
            generalInfoTitle: "Información General",
            trusteeTallyTitle: "Trustee",
            trusteeTallySubTitle: "Estado de importación del fragmento de clave",
            createTallySuccess: "Recuento creado",
            createTallyError: "Error creando recuento",
            startTallySuccess: "Recuento iniciado",
            startTallyError: "Error iniciando recuento",
            startTallyCeremonySuccess: "Iniciada la ceremonya del recuento",
            startTallyCeremonyError: "No se ha podido iniciar la ceremonia del recuento",
            cancelTallyCeremonySuccess: "Cancelada la ceremonya del recuento",
            cancelTallyCeremonyError: "No se ha podido cancelar la ceremonia del recuento",
            recountTallyCeremony: "Repetir el recuento",
            recountTallyCeremonyMessage: "Esto generará un nuevo evento de resultados para la sesión de recuento completada.",
            recountTallyCeremonyStarting: "Iniciando el recuento...",
            recountTallyCeremonySuccess: "Recuento iniciado",
            recountTallyCeremonyError: "No se ha podido iniciar el recuento",
            recountTallyCeremonyOk: "Repetir el recuento",
            trusteeTitle: "Proceso del trustee",
            trusteeSubTitle: "Por favor, importe su fragmento de clave",
            invited: "Has sido invitado a participar en una ceremonia de recuento. Por favor, ",
            click: "haz clic en la acción de recuento",
            participate: "para participar.",
            breadcrumbSteps: {
                start: "Inicio",
                finish: "Final",
                tally: "Recuento",
                results: "Resultados",
                ceremony: "Ceremonia",
            },
            common: {
                title: "Recuento",
                subTitle: "Configuración del Recuento.",
                cancel: "Atras",
                next: "Siguiente",
                date: "Fecha de Recuento",
                global: "Global",
                noTrustees: "No hay trustees aún",
                imported: " trustees han importado su fragmento de clave",
                needed: " trustees necesarios para el recuento",
                start: "Iniciar Recuento",
                ceremony: "Iniciar Ceremonia de Recuento",
                initialization: "Iniciar informe de inicialización",
                results: "Resultados",
                dialog: {
                    ok: "Ok",
                    okTally: "Iniciar recuento",
                    okCancel: "Cancelar recuento",
                    cancel: "Cerrar",
                    title: "¿Estás seguro de que quieres iniciar una ceremonia?",
                    tallyTitle: "¿Estás seguro de que quieres iniciar el recuento?",
                    cancelTitle: "¿Estás seguro de que quieres cancelar el recuento?",
                    message: "Estás a punto de iniciar una ceremonia de recuento. Esta acción notificará a los trustees para importar sus fragmentos de clave.",
                    cancelMessage: "Estás a punto de cancelar la ceremonia de recuento. Esta acción no se puede deshacer.",
                    ceremony: "Todos los trustees requeridos han verificado sus fragmentos de clave. Todo está listo para comenzar a recibir resultados. ¿Desea iniciar el Recuento?",
                    startAutomatedTallyMessage: "Selecciona 'Start Tally' para ejecutar el proceso de recuento y mostrar los resultados, o 'Close' para cancelar.",
                },
            },
            table: {
                elections: "Elecciones",
                selected: "Seleccionadas",
                status: "Estado",
                progress: "Progreso",
                method: "Método de Recuento",
                elegible: "Votantes Elegibles",
                number: "Número de Votos",
                total: "Total",
                turnout: "%",
                candidates: "Resultados de Candidatos",
                options: "Optiones",
                global: "Resumen de participación",
                elegible_census: "Censo de votantes elegibles",
                cast_votes: "Número de Votos",
                cast_votes_percent: "Porcentajes de Votos",
                total_votes: "Total de votantes",
                total_votes_percent: "Participación",
                total_votes_counted: "Total de Votos Contados",
                total_auditable_votes: "Total de Votos Auditables",
                total_valid_votes: "Total de votos válidos",
                total_valid_votes_percent: "Porcentaje de votos válidos",
                total_invalid_votes: "Total de votos inválidos",
                total_invalid_votes_percent: "Porcentaje de votos inválidos",
                explicit_invalid_votes: "Votos explícitamente inválidos",
                explicit_invalid_votes_percent: "Porcentaje de votos explícitamente inválidos",
                implicit_invalid_votes: "Votos implícitamente inválidos",
                implicit_invalid_votes_percent: "Porcentaje de votos implícitamente inválidos",
                blank_votes: "Votos en blanco",
                explicit_blank_votes: "Votos en blanco explícitos",
                implicit_blank_votes: "Votos en blanco implícitos",
                blank_votes_percent: "Porcentaje de votos en blanco",
                number_of_votes: "Número de votos",
                winning_position: "Posición ganadora",
                weight: "Peso",
                preferential: {
                    candidate: "Candidato",
                    winner: "Ganador",
                    eliminated: "Eliminado",
                    round: "Ronda",
                },
                total_declined_to_vote: "Total de votos de renuncia",
                total_blank_ballots: "Total de Papeletas en Blanco",
                participation_by_channel: "Participación por canal",
                channel: "Canal",
                channel_online: "En línea",
                channel_kiosk: "Quiosco",
                channel_early_voting: "Votación anticipada",
                channel_telephone: "Teléfono",
                channel_paper: "Papel",
                channel_postal: "Postal",
                channel_in_person: "Presencial",
                acclamation_note: "Elegido por aclamación. Esta votación se resolvió sin votación, por lo que no se registró ningún voto.",
            },
            pendingResolutions: {
                round: "Ronda {{round}}",
                tieResolutionRequired: "Resolución de empate necesaria",
                tieResolved: "Empate resuelto",
                globalArea: "Global",
                pendingResolutionsHeader: "Resoluciones pendientes",
                pendingResolutionStatus: "Resolución pendiente",
                resolvedStatus: "Resuelta",
                resolutionTitle: "Resolución",
                selectContest: "Seleccione un elemento a la izquierda para ver los detalles",
                selectCandidateToAdvance: "Seleccione el candidato a avanzar",
                undoResolution: "Deshacer resolución",
                applyResolutions: "Aplicar resoluciones y recalcular",
                submitSuccess: "Resoluciones enviadas. El recuento está reanudando...",
                submitError: "Error al enviar las resoluciones. Por favor, inténtelo de nuevo.",
                filter: "Filtrar",
                save: "Guardar",
                pendingApplyStatus: "Cálculo pendiente",
                filterElection: "Elección",
                filterContest: "Concurso",
                filterArea: "Área",
                filterStatusLabel: "Estado",
                clearFilters: "Borrar filtros",
                candidateWithVotes: "{{name}} ({{votes}} votos)",
                candidateWithVotesAndPercent: "{{name}} ({{votes}} votos, {{percent}}%)",
                tieInfoTitle: "Recuento pausado por empate sin resolver (Ronda {{round}})",
                tieInfoBody: "Candidatos empatados ({{votes}} votos, {{percent}}%): {{candidates}}. Se requiere desempate manual para continuar el recuento.",
                tallyResumedTitle: "Recuento reanudado tras aplicar la resolución",
                tallyResumedBody: "El empate fue resuelto el {{date}} por {{user}}",
            },
            chart: {
                votesForCandidates: "Votos por Candidatos",
                blankVotes: "Votos en Blanco",
                invalidVotes: "Votos Inválidos",
                totalVoters: "Total de Votantes",
                nonVoters: "No Votantes",
            },
            exportAllAreas: "Exportar los resultados de todas las áreas en formato {{format}} para '{{item}}'",
        },
        publish: {
            preview: {
                publicationAreas: "Selecciona el área para la vista previa",
                action: "Vista previa",
                copy: "Copiar enlace",
                copy_success: "Se copió correctamente el enlace de vista previa",
                copy_error: "No se pudo copiar el enlace de vista previa",
                success: "Éxito al abrir la vista previa",
            },
            header: {
                change: "Cambios a Publicar",
                viewChange: "Ver Publicación",
                history: "Historico de Cambios",
            },
            action: {
                generateInitializationReport: "Generar Informe de Inicialización",
                startVotingPeriod: "Comenzar votación",
                startKioskVoting: "Comenzar Votación en Quiosco",
                startOnlineVoting: "Comenzar Votación en Línea",
                startEarlyVoting: "Comenzar Votación Anticipada",
                startTelephoneVoting: "Comenzar Votación Telefónica",
                stopVotingPeriod: "Detener votación",
                stopOnlineVoting: "Detener Votación en Línea",
                stopEarlyVoting: "Detener Votación Anticipada",
                stopTelephoneVoting: "Detener Votación Telefónica",
                stopKioskVotingPeriod: "Cerrar Quiosco",
                pauseVotingPeriod: "Pausar votación",
                pauseKioskVoting: "Pausar Votación en Quiosco",
                pauseOnlineVoting: "Pausar Votación en Línea",
                pauseEarlyVoting: "Pausar Votación Anticipada",
                pauseTelephoneVoting: "Pausar Votación Telefónica",
                generate: "regenerar",
                publish: "Publicar Cambios",
                back: "Atrás",
            },
            empty: {
                header: "Ninguna Publicación aún.",
                action: "Generar Publicación",
            },
            forbidden: {
                header: "No es posible Publicar hasta que la Ceremonia de Llaves haya terminado.",
            },
            dialog: {
                title: "Confirmar Acción",
                info: "Has hecho clic en una acción sensible, por lo que necesitamos que la confirmes para poder continuar.",
                initializationInfo: "Estás a punto de generar el informe de inicialización. ¿Estás seguro de que deseas continuar?",
                startInfo: "Está a punto de comenzar el período de votación. ¿Está seguro de que desea continuar?",
                stopInfo: "Está a punto de detener el período de votación. ¿Está seguro de que desea continuar?",
                kioskStopInfo: "Estás a punto de detener el período de votación en el quiosco. ¿Estás seguro de que deseas continuar?",
                pauseInfo: "Está a punto de pausar el período de votación. ¿Está seguro de que desea continuar?",
                publishInfo: "Estás a punto de generar una publicación. ¿Estás seguro de que deseas continuar?",
                ok: "Confirmar",
                ko: "Cancelar",
                error: "Error al cargar las papeletas publicadas",
                error_publish: "Error al publicar la papeleta",
                error_capacity: "Fallo al generar el estilo de papeleta: {{message}}",
                error_status: "Error al cambiar el estado de la publicación",
                error_preview: "Error al obtener la vista previa de la publicación",
                diff: "Renderizar todos los cambios podría hacer que la página no responda. ¿Estás seguro de que quieres continuar?",
                confirmation: "La acción que estás a punto de realizar es sensible y requiere confirmación. Por favor, introduce tu contraseña para continuar con {{action}}.",
            },
            label: {
                current: "Actual",
                previous: "Publicación Anterior",
                diff: "Cambios a publicar",
                publication: "Publicación",
            },
            notifications: {
                generated: "Papeleta generada",
                published: "Papeleta publicada",
                change_status: "Votación cambiada de estado",
            },
        },
        emailEditor: {
            subject: "Asunto del Email",
            tabs: {
                plaintext: "Cuerpo de Texto Plano",
                richtext: "Cuerpo de Texto Enriquecido",
            },
        },
        sendCommunication: {
            send: "Enviar",
            title: "Enviar Notificación",
            subtitle: "Enviar una notificación a usuarios/votantes.",
            sendButton: "Enviar Notificación",
            voters: "Audiencia",
            schedule: "Calendario",
            nowInput: "Enviar ahora",
            dateInput: "Fecha y hora de comienzo de envío",
            chooseDate: "Por favor escoge una fecha",
            languages: "Idiomas",
            smsMessage: "Mensaje SMS",
            errorSending: "Error enviando la notificación: {{error}}",
            successSending: "Notificación programada/enviada con éxito",
            method: "Método de Plantillas",
            type: "Tipo de Comunicación",
            alias: "Alias de la Plantilla",
            votersSelection: {
                ALL_USERS: "Todos",
                NOT_VOTED: "Los que no votaron",
                VOTED: "Los que ya votaron",
                SELECTED: "A {{total}} Votantes seleccionados",
            },
            path: {
                users: "usuarios",
                voters: "votantes",
            },
            methodTitle: "Método de Comunicación",
            communicationMethod: {
                EMAIL: "Email",
                SMS: "SMS",
            },
            communicationType: {
                CREDENTIALS: "Credenciales",
                BALLOT_RECEIPT: "Comprobante de Votación",
            },
            email: {
                subject: "Subject",
            },
        },
        tallysheet: {
            title: "Urnas",
            subtitle: "Urnas digitalizadas por canal",
            createTallySuccess: "Hoja de Recuento creada",
            createTallyError: "Error creando Hoja de Recuento",
            createTallyErrorSameKindExists: "La hoja de recuento ya existe para esta contienda con el mismo canal y área",
            allFieldsRequired: "Todos los campos son obligatorios",
            header: {
                change: "Changes to be Published",
                viewChange: "View Publication",
                history: "Publish History",
            },
            action: {
                start: "Start Election",
                stop: "Stop Election",
                pause: "Pause",
                generate: "Regenerate",
                publish: "Publish Changes",
                back: "Back",
            },
            inputError: {
                totalValidDoesNotMatch: "Los votos de candidatos ({{candidateVotesSum}}) deben estar entre {{lowerBound}} y {{upperBound}} según las reglas de votación de esta contienda ({{nonBlankValidVotes}} votos válidos no en blanco × hasta {{maxMarks}} marcas por papeleta)",
                censusTooSmall: "El total de votos ({{totalVotes}}) no puede ser mayor que el censo ({{census}})",
                totalInvalidDoesNotMatch: "El total de votos inválidos ({{totalInvalid}}) debe ser igual a los votos inválidos implícitos ({{implicitInvalid}}) más los votos inválidos explícitos ({{explicitInvalid}})",
                totalVotesDoesNotMatch: "El total de votos ({{totalVotes}}) debe ser igual al total de votos válidos ({{totalValidVotes}}) más el total de votos inválidos ({{totalInvalid}})",
                unknownCountingAlgorithm: "El algoritmo de recuento de esta contienda ({{countingAlgorithm}}) no se reconoce, por lo que no se puede determinar el número permitido de votos de candidatos. Revise la configuración de la contienda.",
                blankBallotsInconsistent: "Las Papeletas en Blanco deben tener el mismo valor en todas las hojas de escrutinio de esta urna",
                blankBallotsOutOfBounds: "El valor de Papeletas en Blanco está fuera del rango que implican los recuentos de votos en blanco por contienda de esta urna",
            },
            label: {
                area: "Area",
                channel: "Channel",
                total_votes: "Votos Totales",
                total_valid_votes: "Votos Válidos Totales",
                total_invalid: "Votos Inválidos Totales",
                explicit_invalid: "Votos Explícitamente Inválidos",
                implicit_invalid: "Votos Implícitamente Inválidos",
                total_blank_votes: "Votos en Blanco Totales",
                blank_ballots: "Papeletas en Blanco",
                census: "Censo",
            },
            common: {
                tallyCeremony: {
                    manage: "Gestionar la Ceremonia de Cómputo",
                    view: "Ver la Ceremonia de Cómputo",
                    cancel: "Cancelar la Ceremonia de Cómputo",
                    addKey: "Agregar Clave de Cómputo",
                },
                edit: "Editar",
                confirm: "Confirmar",
                back: "Atras",
                next: "Siguiente",
                cancel: "Atras",
                data: "Data",
                title: "Hoja de Recuento",
                subtitle: "Configuración de la Hoja de Recuento.",
                candidates: "Candidatos",
                save: "Guardar",
                approve: "Aprobar",
                disapprove: "Desaprobar",
                show: "Mostrar",
                add: "Añadir",
                versions: "Versiones",
                warningDisapprove: "¿Está seguro de desaprobar esta Hoja de Recuento?",
                warningApprove: "¿Está seguro de aprobar esta Hoja de Recuento?",
            },
            empty: {
                header: "No hay Hojas de Recuento.",
                action: "Generar Hoja de Recuento",
                add: "Añadir",
            },
            breadcrumbSteps: {
                start: "Inicio",
                edit: "Editar",
                confirm: "Confirmar",
                view: "Ver",
            },
            table: {
                area: "Area",
                contest: "Cotienda",
                approvedVersion: "Versión aprobada",
                latestVersion: "Última versión",
                labels: "Etiquetas",
                annotations: "Anotaciones",
            },
            versionsTable: {
                title: "Versiones de la urna",
                version: "Versión",
                createdBy: "Creado por",
                reviewedBy: "Revisado por",
                createdAt: "Creado el",
                reviewedAt: "Revisado el",
                sourceImport: "Importación de origen",
                importStatus: "Estado de importación",
                openImport: "Abrir importación",
                sourceFile: "Archivo de origen",
            },
            message: {
                reviewError: "Error revisando la Hoja de Recuento",
                reviewSuccess: "Hoja de Recuento revisada",
            },
        },
        application: {
            import: {
                title: "Importar Aplicaciones",
                subtitle: "Importar datos de aplicaciones",
                paragraph: "Importa aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
                messages: {
                    success: "Aplicaciones importadas con éxito",
                    error: "Error al importar las aplicaciones",
                },
            },
            export: {
                title: "Exportar Aplicaciones",
                subtitle: "Exportar datos de aplicaciones",
                button: "Exportar",
                paragraph: "Exporta aplicaciones usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV).",
                messages: {
                    success: "Aplicaciones exportadas con éxito",
                    error: "Error al exportar las aplicaciones",
                },
            },
        },
        template: {
            noPermissions: "No tienes permisos para acceder a las Plantillas.",
            title: "Plantillas",
            subtitle: "Listado de plantillas",
            chooseMethods: "Elige métodos",
            default: "Usar plantilla predeterminada",
            empty: {
                title: "No hay plantillas",
                subtitle: "¿Quieres crear una nueva?",
            },
            action: {
                createOne: "Crear Plantilla",
            },
            create: {
                title: "Crear una Plantilla",
                success: "Plantilla creada",
                error: "Error creando plantilla",
            },
            update: {
                success: "Plantilla actualizada",
                error: "Error actualizando plantilla",
            },
            edit: {
                title: "Editar una Plantilla",
            },
            form: {
                smsMessage: "Mensaje SMS",
                document: "Documento",
                pdfOptions: "Opciones de PDF",
                name: "Nombre de la Plantilla",
                alias: "Alias de la Plantilla",
                type: "Tipo",
                communicationMethod: "Método",
                reportOptions: "Opciones de Informe",
            },
            type: {
                CREDENTIALS: "Credenciales",
                INITIALIZATION_REPORT: "Informe de Inicialización",
                ELECTORAL_RESULTS: "Resultados Electorales",
                BALLOT_IMAGES: "Imágenes de Boletas",
                BALLOT_RECEIPT: "Recibo de Voto",
                ACTIVITY_LOGS: "Registros de Actividades",
                MANUAL_VERIFICATION: "Verificación Manual",
                PARTICIPATION_REPORT: "Informe de Participación",
            },
            method: {
                email: "Email",
                sms: "SMS",
                document: "Documento",
            },
            import: {
                title: "Importar Plantillas",
                subtitle: "Importar datos de plantillas",
                paragraph: "Importa plantillas usando un archivo de hoja de cálculo en formato de valores separados por comas (CSV). Descarga un archivo CSV de ejemplo aquí.",
            },
        },
        materials: {
            createMaterialSuccess: "Material de soporte creado",
            createMaterialError: "Error creando material de soporte",
            updateMaterialSuccess: "Material de soporte actualizado",
            updateMaterialError: "Error actualizando material de soporte",
            common: {
                title: "Materiales de Soporte",
                subtitle: "Entrar datos del material de soporte.",
            },
            error: {
                title: "El título es obligatorio",
                document: "El documento es obligatorio",
            },
            fields: {
                isHidden: "Oculto",
                publicUrl: "Enlace público",
            },
            empty: {
                header: "Aún no hay material de soporte",
                action: "Generar material de soporte",
            },
        },
        widget: {
            logs: "Registros",
        },
        settings: {
            countries: {
                title: "Bloqueo de Países",
                votingDescription: "Elige a continuación los países de los cuales deseas bloquear las votaciones.",
                enrollmentDescription: "Elige a continuación los países de los cuales deseas bloquear las preinscripciones.",
                error: {
                    errorSaving: "Error al guardar la lista de países",
                },
            },
            backupRestore: {
                title: "Copia de seguridad / Restaurar configuración del inquilino",
                backup: {
                    label: "Respaldo",
                    subtitle: "Copia de seguridad de las configuraciones del inquilino",
                },
                restore: {
                    label: "Restaurar",
                    subtitle: "Restaurar la configuración del inquilino",
                    title: "Importar configuraciones del inquilino",
                    paragraph: "Importar configuraciones del inquilino, configuraciones de Keycloak, roles y datos de permisos usando una carpeta comprimida.",
                    tenantConfigOption: "Importar configuraciones del inquilino",
                    keycloakConfigOption: "Importar configuraciones de Keycloak",
                    RolesConfigOption: "Importar configuraciones de roles y permisos",
                },
            },
            previewScreen: {
                label: "Vistas Previas",
                noContent: "No se encontraron vistas previas",
                table: {
                    title: "Vistas previas externas",
                    description: "Un registro de las vistas previas de estilos de papeleta generadas mediante peticiones externas",
                    requestedBy: "Solicitado por",
                    document: "Documento",
                    url: "URL",
                },
            },
            languages: {
                default: "Idioma predeterminado",
            },
        },
        approvalsScreen: {
            column: {
                status: "Estado",
                id: "ID",
                applicantId: "ID del Solicitante",
                verificationType: "Tipo de Verificación",
                createdAt: "Creado El",
                updatedAt: "Actualizado El",
                verified_by: "Aprobado Por",
            },
            approvalRequest: "Solicitud de Aprobación",
            title: "Votantes",
            subtitle: "Buscar votantes coincidentes",
            approve: {
                body: "¿Estás seguro de que deseas aprobar a este votante? Esta acción no se puede deshacer.",
            },
            reject: {
                label: "Rechazar la solicitud",
                confirm: "¿Estás seguro de que deseas rechazar a este votante? Esta acción no es reversible.",
                message: "Escribe aquí el motivo del rechazo",
                rejectReason: "Motivo del rechazo",
                messageRequired: "Se requiere un mensaje de rechazo para la opción 'Otro'",
                reasons: {
                    "undefined": "-",
                    "insufficient-information": "Datos Faltantes",
                    "no-matching-voter": "Votante no Coincidente",
                    "voter-already-approved": "Ya Aprobado",
                    "other": "Otro",
                },
            },
            notifications: {
                approveError: "Error al aprobar al votante",
                approveSuccess: "Votante aprobado",
                rejectError: "Error al rechazar al votante",
                rejectSuccess: "Votante rechazado",
                VoterApprovedAlready: "El votante ya está aprobado.",
            },
            export: {
                success: "La exportación de aplicaciones se completó con éxito",
                error: "Error al exportar las aplicaciones",
            },
        },
        monitoringDashboardScreen: {
            voters: {
                title: "Votantes",
                enrolledOverseasVoters: "Votantes Inscritos en el Extranjero",
                approvalStatus: "Estado de Aprobación: Votantes Aprobados/Desaprobados",
                manuallyApproval: "Votantes Aprobados/Desaprobados Manualmente",
                automaticallyApproval: "Votantes Aprobados/Desaprobados Automáticamente",
                authenticatedVoters: "Votantes Autenticados",
                invalidUserErrors: "Errores de Usuario Inválido:",
                invalidPasswordErrors: "Errores de Contraseña Inválida:",
            },
            polls: {
                title: "Encuestas",
                initializedSystems: "Publicaciones con Sistemas Inicializados",
                votingOpened: "Publicaciones con Votación Abierta",
                votingClosed: "Publicaciones con Votación Cerrada",
                votingStarted: "Publicaciones con Votación Iniciada",
                voterTurnout: "Participación de los Votantes",
            },
            tally: {
                title: "Conteo",
                activeVotesCounting: "Publicaciones con Conteo de Votos Activo",
                generatedERs: "Publicaciones con ERs Generados",
                transmittedResults: "Publicaciones con Resultados Transmitidos",
            },
            testing: {
                title: "Pruebas",
                testElectionVoterCount: "Conteo de Votantes en Elección de Prueba",
            },
        },
        certificateAuthorities: {
            title: "Certificados",
            subtitle: "Autoridades de certificación (CA) de confianza para este evento electoral. Los CA importados se usan para validar los certificados de los votantes.",
            importButton: "Importar certificados",
            type: {
                root: "Raíz",
                intermediate: "Intermedio",
            },
            expiry: {
                expired: "Vencido",
                expiringSoon: "Por vencer",
                valid: "Válido",
            },
            columns: {
                commonName: "Nombre común",
                type: "Tipo",
                issuerCn: "CN del emisor",
                notBefore: "Válido desde",
                notAfter: "Vence",
                fingerprint: "Huella SHA256",
            },
            importDialog: {
                title: "Importar autoridades de certificación",
                subtitle: "Importar uno o más certificados CA desde un archivo PEM",
                description: "Seleccione un archivo PEM que contenga uno o más certificados. Se admiten paquetes — cada certificado se importa individualmente.",
                selectFile: "Seleccionar archivo PEM",
                fileLoaded: "Archivo cargado ({{bytes}} bytes)",
                importButton: "Importar",
            },
            notify: {
                importSuccess: "Se importaron {{inserted}} certificado(s).",
                importSkipped: "{{count}} certificado(s) omitido(s) (ya presentes).",
                importErrors: "Problemas en la importación: {{errors}}",
                importError: "Error al importar: {{error}}",
                deleteSuccess: "Certificado eliminado.",
                deleteError: "Error al eliminar el certificado.",
                exportSuccess: "Certificado(s) exportado(s) correctamente.",
                exportError: "Error al exportar los certificados.",
            },
            exportDialog: {
                title: "Exportar autoridades de certificación",
                description: "Está a punto de exportar {{amount}} certificado(s).",
                all: "todos",
            },
            deleteDialog: {
                description: "¿Está seguro de que desea eliminar {{count}} certificado(s)?",
            },
            emptyHeader: "No se han importado autoridades de certificación para este evento electoral.",
            fileReadError: "Error al leer el archivo.",
            viewDialog: {
                title: "Detalles de la autoridad de certificación",
                subject: "Asunto",
                issuer: "Emisor",
                serialNumber: "Número de serie",
                pemContent: "Contenido PEM",
            },
            confirmDelete: "Eliminar autoridad de certificación",
            confirmDeleteDescription: '¿Está seguro de que desea eliminar el certificado "{{name}}" (huella: {{fingerprint}})?',
        },
    },
};
export default spanishTranslation;
